var map = {
	"./20px/mi-airplane-arrival.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-airplane-arrival.js",
		"node_modules_maersk-global_icons_js_20px_mi-airplane-arrival_js"
	],
	"./20px/mi-airplane-departure.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-airplane-departure.js",
		"node_modules_maersk-global_icons_js_20px_mi-airplane-departure_js"
	],
	"./20px/mi-airplane.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-airplane.js",
		"node_modules_maersk-global_icons_js_20px_mi-airplane_js"
	],
	"./20px/mi-anchor.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-anchor.js",
		"node_modules_maersk-global_icons_js_20px_mi-anchor_js"
	],
	"./20px/mi-apple-alt.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-apple-alt.js",
		"node_modules_maersk-global_icons_js_20px_mi-apple-alt_js"
	],
	"./20px/mi-apple.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-apple.js",
		"node_modules_maersk-global_icons_js_20px_mi-apple_js"
	],
	"./20px/mi-arrow-all-directions.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-arrow-all-directions.js",
		"node_modules_maersk-global_icons_js_20px_mi-arrow-all-directions_js"
	],
	"./20px/mi-arrow-anti-clockwise-clock.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-arrow-anti-clockwise-clock.js",
		"node_modules_maersk-global_icons_js_20px_mi-arrow-anti-clockwise-clock_js"
	],
	"./20px/mi-arrow-anti-clockwise.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-arrow-anti-clockwise.js",
		"node_modules_maersk-global_icons_js_20px_mi-arrow-anti-clockwise_js"
	],
	"./20px/mi-arrow-clockwise-clock.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-arrow-clockwise-clock.js",
		"node_modules_maersk-global_icons_js_20px_mi-arrow-clockwise-clock_js"
	],
	"./20px/mi-arrow-clockwise-times.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-arrow-clockwise-times.js",
		"node_modules_maersk-global_icons_js_20px_mi-arrow-clockwise-times_js"
	],
	"./20px/mi-arrow-clockwise.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-arrow-clockwise.js",
		"node_modules_maersk-global_icons_js_20px_mi-arrow-clockwise_js"
	],
	"./20px/mi-arrow-curved-up-left.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-arrow-curved-up-left.js",
		"node_modules_maersk-global_icons_js_20px_mi-arrow-curved-up-left_js"
	],
	"./20px/mi-arrow-curved-up-right.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-arrow-curved-up-right.js",
		"node_modules_maersk-global_icons_js_20px_mi-arrow-curved-up-right_js"
	],
	"./20px/mi-arrow-down-circle.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-arrow-down-circle.js",
		"node_modules_maersk-global_icons_js_20px_mi-arrow-down-circle_js"
	],
	"./20px/mi-arrow-down-left.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-arrow-down-left.js",
		"node_modules_maersk-global_icons_js_20px_mi-arrow-down-left_js"
	],
	"./20px/mi-arrow-down-right.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-arrow-down-right.js",
		"node_modules_maersk-global_icons_js_20px_mi-arrow-down-right_js"
	],
	"./20px/mi-arrow-down-square-dashed.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-arrow-down-square-dashed.js",
		"node_modules_maersk-global_icons_js_20px_mi-arrow-down-square-dashed_js"
	],
	"./20px/mi-arrow-down-square.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-arrow-down-square.js",
		"node_modules_maersk-global_icons_js_20px_mi-arrow-down-square_js"
	],
	"./20px/mi-arrow-down.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-arrow-down.js",
		"node_modules_maersk-global_icons_js_20px_mi-arrow-down_js"
	],
	"./20px/mi-arrow-from-bottom.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-arrow-from-bottom.js",
		"node_modules_maersk-global_icons_js_20px_mi-arrow-from-bottom_js"
	],
	"./20px/mi-arrow-from-left.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-arrow-from-left.js",
		"node_modules_maersk-global_icons_js_20px_mi-arrow-from-left_js"
	],
	"./20px/mi-arrow-from-right.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-arrow-from-right.js",
		"node_modules_maersk-global_icons_js_20px_mi-arrow-from-right_js"
	],
	"./20px/mi-arrow-from-top.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-arrow-from-top.js",
		"node_modules_maersk-global_icons_js_20px_mi-arrow-from-top_js"
	],
	"./20px/mi-arrow-left-circle.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-arrow-left-circle.js",
		"node_modules_maersk-global_icons_js_20px_mi-arrow-left-circle_js"
	],
	"./20px/mi-arrow-left.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-arrow-left.js",
		"node_modules_maersk-global_icons_js_20px_mi-arrow-left_js"
	],
	"./20px/mi-arrow-right-circle.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-arrow-right-circle.js",
		"node_modules_maersk-global_icons_js_20px_mi-arrow-right-circle_js"
	],
	"./20px/mi-arrow-right.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-arrow-right.js",
		"node_modules_maersk-global_icons_js_20px_mi-arrow-right_js"
	],
	"./20px/mi-arrow-to-bottom.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-arrow-to-bottom.js",
		"node_modules_maersk-global_icons_js_20px_mi-arrow-to-bottom_js"
	],
	"./20px/mi-arrow-to-left.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-arrow-to-left.js",
		"node_modules_maersk-global_icons_js_20px_mi-arrow-to-left_js"
	],
	"./20px/mi-arrow-to-right.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-arrow-to-right.js",
		"node_modules_maersk-global_icons_js_20px_mi-arrow-to-right_js"
	],
	"./20px/mi-arrow-to-top.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-arrow-to-top.js",
		"node_modules_maersk-global_icons_js_20px_mi-arrow-to-top_js"
	],
	"./20px/mi-arrow-up-circle.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-arrow-up-circle.js",
		"node_modules_maersk-global_icons_js_20px_mi-arrow-up-circle_js"
	],
	"./20px/mi-arrow-up-left.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-arrow-up-left.js",
		"node_modules_maersk-global_icons_js_20px_mi-arrow-up-left_js"
	],
	"./20px/mi-arrow-up-merge.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-arrow-up-merge.js",
		"node_modules_maersk-global_icons_js_20px_mi-arrow-up-merge_js"
	],
	"./20px/mi-arrow-up-right.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-arrow-up-right.js",
		"node_modules_maersk-global_icons_js_20px_mi-arrow-up-right_js"
	],
	"./20px/mi-arrow-up-square-dashed.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-arrow-up-square-dashed.js",
		"node_modules_maersk-global_icons_js_20px_mi-arrow-up-square-dashed_js"
	],
	"./20px/mi-arrow-up-square.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-arrow-up-square.js",
		"node_modules_maersk-global_icons_js_20px_mi-arrow-up-square_js"
	],
	"./20px/mi-arrow-up.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-arrow-up.js",
		"node_modules_maersk-global_icons_js_20px_mi-arrow-up_js"
	],
	"./20px/mi-arrows-down-up.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-arrows-down-up.js",
		"node_modules_maersk-global_icons_js_20px_mi-arrows-down-up_js"
	],
	"./20px/mi-arrows-left-line-right.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-arrows-left-line-right.js",
		"node_modules_maersk-global_icons_js_20px_mi-arrows-left-line-right_js"
	],
	"./20px/mi-arrows-left-right.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-arrows-left-right.js",
		"node_modules_maersk-global_icons_js_20px_mi-arrows-left-right_js"
	],
	"./20px/mi-arrows-right-line-left.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-arrows-right-line-left.js",
		"node_modules_maersk-global_icons_js_20px_mi-arrows-right-line-left_js"
	],
	"./20px/mi-banana.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-banana.js",
		"node_modules_maersk-global_icons_js_20px_mi-banana_js"
	],
	"./20px/mi-barcode-scan.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-barcode-scan.js",
		"node_modules_maersk-global_icons_js_20px_mi-barcode-scan_js"
	],
	"./20px/mi-barcode.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-barcode.js",
		"node_modules_maersk-global_icons_js_20px_mi-barcode_js"
	],
	"./20px/mi-barrel.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-barrel.js",
		"node_modules_maersk-global_icons_js_20px_mi-barrel_js"
	],
	"./20px/mi-bars-horizontal-bullets.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-bars-horizontal-bullets.js",
		"node_modules_maersk-global_icons_js_20px_mi-bars-horizontal-bullets_js"
	],
	"./20px/mi-bars-horizontal-funnel-down.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-bars-horizontal-funnel-down.js",
		"node_modules_maersk-global_icons_js_20px_mi-bars-horizontal-funnel-down_js"
	],
	"./20px/mi-bars-horizontal-funnel-left.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-bars-horizontal-funnel-left.js",
		"node_modules_maersk-global_icons_js_20px_mi-bars-horizontal-funnel-left_js"
	],
	"./20px/mi-bars-horizontal.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-bars-horizontal.js",
		"node_modules_maersk-global_icons_js_20px_mi-bars-horizontal_js"
	],
	"./20px/mi-battery-bolt.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-battery-bolt.js",
		"node_modules_maersk-global_icons_js_20px_mi-battery-bolt_js"
	],
	"./20px/mi-battery-solid.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-battery-solid.js",
		"node_modules_maersk-global_icons_js_20px_mi-battery-solid_js"
	],
	"./20px/mi-battery.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-battery.js",
		"node_modules_maersk-global_icons_js_20px_mi-battery_js"
	],
	"./20px/mi-bell-slash.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-bell-slash.js",
		"node_modules_maersk-global_icons_js_20px_mi-bell-slash_js"
	],
	"./20px/mi-bell-solid.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-bell-solid.js",
		"node_modules_maersk-global_icons_js_20px_mi-bell-solid_js"
	],
	"./20px/mi-bell.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-bell.js",
		"node_modules_maersk-global_icons_js_20px_mi-bell_js"
	],
	"./20px/mi-between.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-between.js",
		"node_modules_maersk-global_icons_js_20px_mi-between_js"
	],
	"./20px/mi-bicycle.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-bicycle.js",
		"node_modules_maersk-global_icons_js_20px_mi-bicycle_js"
	],
	"./20px/mi-binoculars.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-binoculars.js",
		"node_modules_maersk-global_icons_js_20px_mi-binoculars_js"
	],
	"./20px/mi-book-open.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-book-open.js",
		"node_modules_maersk-global_icons_js_20px_mi-book-open_js"
	],
	"./20px/mi-bookmark-solid.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-bookmark-solid.js",
		"node_modules_maersk-global_icons_js_20px_mi-bookmark-solid_js"
	],
	"./20px/mi-bookmark.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-bookmark.js",
		"node_modules_maersk-global_icons_js_20px_mi-bookmark_js"
	],
	"./20px/mi-box.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-box.js",
		"node_modules_maersk-global_icons_js_20px_mi-box_js"
	],
	"./20px/mi-boxes-stacked.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-boxes-stacked.js",
		"node_modules_maersk-global_icons_js_20px_mi-boxes-stacked_js"
	],
	"./20px/mi-briefcase.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-briefcase.js",
		"node_modules_maersk-global_icons_js_20px_mi-briefcase_js"
	],
	"./20px/mi-browser.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-browser.js",
		"node_modules_maersk-global_icons_js_20px_mi-browser_js"
	],
	"./20px/mi-bucket-mop.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-bucket-mop.js",
		"node_modules_maersk-global_icons_js_20px_mi-bucket-mop_js"
	],
	"./20px/mi-bus-side.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-bus-side.js",
		"node_modules_maersk-global_icons_js_20px_mi-bus-side_js"
	],
	"./20px/mi-calculator.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-calculator.js",
		"node_modules_maersk-global_icons_js_20px_mi-calculator_js"
	],
	"./20px/mi-calendar-check.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-calendar-check.js",
		"node_modules_maersk-global_icons_js_20px_mi-calendar-check_js"
	],
	"./20px/mi-calendar-clock.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-calendar-clock.js",
		"node_modules_maersk-global_icons_js_20px_mi-calendar-clock_js"
	],
	"./20px/mi-calendar-exclamation.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-calendar-exclamation.js",
		"node_modules_maersk-global_icons_js_20px_mi-calendar-exclamation_js"
	],
	"./20px/mi-calendar-minus.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-calendar-minus.js",
		"node_modules_maersk-global_icons_js_20px_mi-calendar-minus_js"
	],
	"./20px/mi-calendar-plus.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-calendar-plus.js",
		"node_modules_maersk-global_icons_js_20px_mi-calendar-plus_js"
	],
	"./20px/mi-calendar-times.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-calendar-times.js",
		"node_modules_maersk-global_icons_js_20px_mi-calendar-times_js"
	],
	"./20px/mi-calendar.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-calendar.js",
		"node_modules_maersk-global_icons_js_20px_mi-calendar_js"
	],
	"./20px/mi-camera-cctv.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-camera-cctv.js",
		"node_modules_maersk-global_icons_js_20px_mi-camera-cctv_js"
	],
	"./20px/mi-camera-focus.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-camera-focus.js",
		"node_modules_maersk-global_icons_js_20px_mi-camera-focus_js"
	],
	"./20px/mi-camera.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-camera.js",
		"node_modules_maersk-global_icons_js_20px_mi-camera_js"
	],
	"./20px/mi-captain-hat.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-captain-hat.js",
		"node_modules_maersk-global_icons_js_20px_mi-captain-hat_js"
	],
	"./20px/mi-car-front.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-car-front.js",
		"node_modules_maersk-global_icons_js_20px_mi-car-front_js"
	],
	"./20px/mi-car-side.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-car-side.js",
		"node_modules_maersk-global_icons_js_20px_mi-car-side_js"
	],
	"./20px/mi-caret-down-solid.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-caret-down-solid.js",
		"node_modules_maersk-global_icons_js_20px_mi-caret-down-solid_js"
	],
	"./20px/mi-caret-down.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-caret-down.js",
		"node_modules_maersk-global_icons_js_20px_mi-caret-down_js"
	],
	"./20px/mi-caret-left-solid.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-caret-left-solid.js",
		"node_modules_maersk-global_icons_js_20px_mi-caret-left-solid_js"
	],
	"./20px/mi-caret-left.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-caret-left.js",
		"node_modules_maersk-global_icons_js_20px_mi-caret-left_js"
	],
	"./20px/mi-caret-right-solid.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-caret-right-solid.js",
		"node_modules_maersk-global_icons_js_20px_mi-caret-right-solid_js"
	],
	"./20px/mi-caret-right.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-caret-right.js",
		"node_modules_maersk-global_icons_js_20px_mi-caret-right_js"
	],
	"./20px/mi-caret-up-down-solid.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-caret-up-down-solid.js",
		"node_modules_maersk-global_icons_js_20px_mi-caret-up-down-solid_js"
	],
	"./20px/mi-caret-up-down.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-caret-up-down.js",
		"node_modules_maersk-global_icons_js_20px_mi-caret-up-down_js"
	],
	"./20px/mi-caret-up-solid.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-caret-up-solid.js",
		"node_modules_maersk-global_icons_js_20px_mi-caret-up-solid_js"
	],
	"./20px/mi-caret-up.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-caret-up.js",
		"node_modules_maersk-global_icons_js_20px_mi-caret-up_js"
	],
	"./20px/mi-carrot.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-carrot.js",
		"node_modules_maersk-global_icons_js_20px_mi-carrot_js"
	],
	"./20px/mi-cash.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-cash.js",
		"node_modules_maersk-global_icons_js_20px_mi-cash_js"
	],
	"./20px/mi-chart-arrow-up-right.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-chart-arrow-up-right.js",
		"node_modules_maersk-global_icons_js_20px_mi-chart-arrow-up-right_js"
	],
	"./20px/mi-chart-bars-vertical-stacked.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-chart-bars-vertical-stacked.js",
		"node_modules_maersk-global_icons_js_20px_mi-chart-bars-vertical-stacked_js"
	],
	"./20px/mi-chart-bars-vertical.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-chart-bars-vertical.js",
		"node_modules_maersk-global_icons_js_20px_mi-chart-bars-vertical_js"
	],
	"./20px/mi-chart-donut.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-chart-donut.js",
		"node_modules_maersk-global_icons_js_20px_mi-chart-donut_js"
	],
	"./20px/mi-chart-line-up.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-chart-line-up.js",
		"node_modules_maersk-global_icons_js_20px_mi-chart-line-up_js"
	],
	"./20px/mi-chart-pie.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-chart-pie.js",
		"node_modules_maersk-global_icons_js_20px_mi-chart-pie_js"
	],
	"./20px/mi-chatbot.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-chatbot.js",
		"node_modules_maersk-global_icons_js_20px_mi-chatbot_js"
	],
	"./20px/mi-check-circle-half-dashed.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-check-circle-half-dashed.js",
		"node_modules_maersk-global_icons_js_20px_mi-check-circle-half-dashed_js"
	],
	"./20px/mi-check-circle-solid.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-check-circle-solid.js",
		"node_modules_maersk-global_icons_js_20px_mi-check-circle-solid_js"
	],
	"./20px/mi-check-circle.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-check-circle.js",
		"node_modules_maersk-global_icons_js_20px_mi-check-circle_js"
	],
	"./20px/mi-check-square-copy.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-check-square-copy.js",
		"node_modules_maersk-global_icons_js_20px_mi-check-square-copy_js"
	],
	"./20px/mi-check.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-check.js",
		"node_modules_maersk-global_icons_js_20px_mi-check_js"
	],
	"./20px/mi-chemistry-beakers.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-chemistry-beakers.js",
		"node_modules_maersk-global_icons_js_20px_mi-chemistry-beakers_js"
	],
	"./20px/mi-chevron-down.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-chevron-down.js",
		"node_modules_maersk-global_icons_js_20px_mi-chevron-down_js"
	],
	"./20px/mi-chevron-left.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-chevron-left.js",
		"node_modules_maersk-global_icons_js_20px_mi-chevron-left_js"
	],
	"./20px/mi-chevron-right.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-chevron-right.js",
		"node_modules_maersk-global_icons_js_20px_mi-chevron-right_js"
	],
	"./20px/mi-chevron-up.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-chevron-up.js",
		"node_modules_maersk-global_icons_js_20px_mi-chevron-up_js"
	],
	"./20px/mi-chevrons-left-right.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-chevrons-left-right.js",
		"node_modules_maersk-global_icons_js_20px_mi-chevrons-left-right_js"
	],
	"./20px/mi-chevrons-up-down.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-chevrons-up-down.js",
		"node_modules_maersk-global_icons_js_20px_mi-chevrons-up-down_js"
	],
	"./20px/mi-chicken-drumstick.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-chicken-drumstick.js",
		"node_modules_maersk-global_icons_js_20px_mi-chicken-drumstick_js"
	],
	"./20px/mi-chicken-head.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-chicken-head.js",
		"node_modules_maersk-global_icons_js_20px_mi-chicken-head_js"
	],
	"./20px/mi-chicken-side.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-chicken-side.js",
		"node_modules_maersk-global_icons_js_20px_mi-chicken-side_js"
	],
	"./20px/mi-chip.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-chip.js",
		"node_modules_maersk-global_icons_js_20px_mi-chip_js"
	],
	"./20px/mi-circle-slash.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-circle-slash.js",
		"node_modules_maersk-global_icons_js_20px_mi-circle-slash_js"
	],
	"./20px/mi-clipboard-check-text.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-clipboard-check-text.js",
		"node_modules_maersk-global_icons_js_20px_mi-clipboard-check-text_js"
	],
	"./20px/mi-clipboard-check.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-clipboard-check.js",
		"node_modules_maersk-global_icons_js_20px_mi-clipboard-check_js"
	],
	"./20px/mi-clipboard-list-text.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-clipboard-list-text.js",
		"node_modules_maersk-global_icons_js_20px_mi-clipboard-list-text_js"
	],
	"./20px/mi-clipboard-officer-text.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-clipboard-officer-text.js",
		"node_modules_maersk-global_icons_js_20px_mi-clipboard-officer-text_js"
	],
	"./20px/mi-clipboard-snowflake-text.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-clipboard-snowflake-text.js",
		"node_modules_maersk-global_icons_js_20px_mi-clipboard-snowflake-text_js"
	],
	"./20px/mi-clipboard-text.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-clipboard-text.js",
		"node_modules_maersk-global_icons_js_20px_mi-clipboard-text_js"
	],
	"./20px/mi-clock-alarm.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-clock-alarm.js",
		"node_modules_maersk-global_icons_js_20px_mi-clock-alarm_js"
	],
	"./20px/mi-clock-solid.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-clock-solid.js",
		"node_modules_maersk-global_icons_js_20px_mi-clock-solid_js"
	],
	"./20px/mi-clock-stopwatch.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-clock-stopwatch.js",
		"node_modules_maersk-global_icons_js_20px_mi-clock-stopwatch_js"
	],
	"./20px/mi-clock.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-clock.js",
		"node_modules_maersk-global_icons_js_20px_mi-clock_js"
	],
	"./20px/mi-cloud.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-cloud.js",
		"node_modules_maersk-global_icons_js_20px_mi-cloud_js"
	],
	"./20px/mi-coat.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-coat.js",
		"node_modules_maersk-global_icons_js_20px_mi-coat_js"
	],
	"./20px/mi-cog-play.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-cog-play.js",
		"node_modules_maersk-global_icons_js_20px_mi-cog-play_js"
	],
	"./20px/mi-cog.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-cog.js",
		"node_modules_maersk-global_icons_js_20px_mi-cog_js"
	],
	"./20px/mi-combined-arrow-down.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-combined-arrow-down.js",
		"node_modules_maersk-global_icons_js_20px_mi-combined-arrow-down_js"
	],
	"./20px/mi-combined-arrow-left.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-combined-arrow-left.js",
		"node_modules_maersk-global_icons_js_20px_mi-combined-arrow-left_js"
	],
	"./20px/mi-combined-arrow-right.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-combined-arrow-right.js",
		"node_modules_maersk-global_icons_js_20px_mi-combined-arrow-right_js"
	],
	"./20px/mi-combined-arrow-up.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-combined-arrow-up.js",
		"node_modules_maersk-global_icons_js_20px_mi-combined-arrow-up_js"
	],
	"./20px/mi-comment-dollar.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-comment-dollar.js",
		"node_modules_maersk-global_icons_js_20px_mi-comment-dollar_js"
	],
	"./20px/mi-comment-dots.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-comment-dots.js",
		"node_modules_maersk-global_icons_js_20px_mi-comment-dots_js"
	],
	"./20px/mi-comment-minus.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-comment-minus.js",
		"node_modules_maersk-global_icons_js_20px_mi-comment-minus_js"
	],
	"./20px/mi-comment-off.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-comment-off.js",
		"node_modules_maersk-global_icons_js_20px_mi-comment-off_js"
	],
	"./20px/mi-comment-plus.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-comment-plus.js",
		"node_modules_maersk-global_icons_js_20px_mi-comment-plus_js"
	],
	"./20px/mi-comment.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-comment.js",
		"node_modules_maersk-global_icons_js_20px_mi-comment_js"
	],
	"./20px/mi-comments.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-comments.js",
		"node_modules_maersk-global_icons_js_20px_mi-comments_js"
	],
	"./20px/mi-computer.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-computer.js",
		"node_modules_maersk-global_icons_js_20px_mi-computer_js"
	],
	"./20px/mi-container-down.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-container-down.js",
		"node_modules_maersk-global_icons_js_20px_mi-container-down_js"
	],
	"./20px/mi-container-flat-rack.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-container-flat-rack.js",
		"node_modules_maersk-global_icons_js_20px_mi-container-flat-rack_js"
	],
	"./20px/mi-container-handler-2.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-container-handler-2.js",
		"node_modules_maersk-global_icons_js_20px_mi-container-handler-2_js"
	],
	"./20px/mi-container-handler.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-container-handler.js",
		"node_modules_maersk-global_icons_js_20px_mi-container-handler_js"
	],
	"./20px/mi-container-high-cube.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-container-high-cube.js",
		"node_modules_maersk-global_icons_js_20px_mi-container-high-cube_js"
	],
	"./20px/mi-container-hook.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-container-hook.js",
		"node_modules_maersk-global_icons_js_20px_mi-container-hook_js"
	],
	"./20px/mi-container-in.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-container-in.js",
		"node_modules_maersk-global_icons_js_20px_mi-container-in_js"
	],
	"./20px/mi-container-left.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-container-left.js",
		"node_modules_maersk-global_icons_js_20px_mi-container-left_js"
	],
	"./20px/mi-container-link.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-container-link.js",
		"node_modules_maersk-global_icons_js_20px_mi-container-link_js"
	],
	"./20px/mi-container-open-top.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-container-open-top.js",
		"node_modules_maersk-global_icons_js_20px_mi-container-open-top_js"
	],
	"./20px/mi-container-out.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-container-out.js",
		"node_modules_maersk-global_icons_js_20px_mi-container-out_js"
	],
	"./20px/mi-container-reefer.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-container-reefer.js",
		"node_modules_maersk-global_icons_js_20px_mi-container-reefer_js"
	],
	"./20px/mi-container-right.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-container-right.js",
		"node_modules_maersk-global_icons_js_20px_mi-container-right_js"
	],
	"./20px/mi-container-stacked-alt.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-container-stacked-alt.js",
		"node_modules_maersk-global_icons_js_20px_mi-container-stacked-alt_js"
	],
	"./20px/mi-container-stacked.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-container-stacked.js",
		"node_modules_maersk-global_icons_js_20px_mi-container-stacked_js"
	],
	"./20px/mi-container-tank.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-container-tank.js",
		"node_modules_maersk-global_icons_js_20px_mi-container-tank_js"
	],
	"./20px/mi-container-tracking.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-container-tracking.js",
		"node_modules_maersk-global_icons_js_20px_mi-container-tracking_js"
	],
	"./20px/mi-container-up.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-container-up.js",
		"node_modules_maersk-global_icons_js_20px_mi-container-up_js"
	],
	"./20px/mi-container.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-container.js",
		"node_modules_maersk-global_icons_js_20px_mi-container_js"
	],
	"./20px/mi-contains.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-contains.js",
		"node_modules_maersk-global_icons_js_20px_mi-contains_js"
	],
	"./20px/mi-conveyor-belt.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-conveyor-belt.js",
		"node_modules_maersk-global_icons_js_20px_mi-conveyor-belt_js"
	],
	"./20px/mi-cookie.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-cookie.js",
		"node_modules_maersk-global_icons_js_20px_mi-cookie_js"
	],
	"./20px/mi-copy.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-copy.js",
		"node_modules_maersk-global_icons_js_20px_mi-copy_js"
	],
	"./20px/mi-cotton.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-cotton.js",
		"node_modules_maersk-global_icons_js_20px_mi-cotton_js"
	],
	"./20px/mi-cow-head.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-cow-head.js",
		"node_modules_maersk-global_icons_js_20px_mi-cow-head_js"
	],
	"./20px/mi-cow-side.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-cow-side.js",
		"node_modules_maersk-global_icons_js_20px_mi-cow-side_js"
	],
	"./20px/mi-crane.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-crane.js",
		"node_modules_maersk-global_icons_js_20px_mi-crane_js"
	],
	"./20px/mi-credit-card-back.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-credit-card-back.js",
		"node_modules_maersk-global_icons_js_20px_mi-credit-card-back_js"
	],
	"./20px/mi-credit-card-front.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-credit-card-front.js",
		"node_modules_maersk-global_icons_js_20px_mi-credit-card-front_js"
	],
	"./20px/mi-crosshair.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-crosshair.js",
		"node_modules_maersk-global_icons_js_20px_mi-crosshair_js"
	],
	"./20px/mi-database.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-database.js",
		"node_modules_maersk-global_icons_js_20px_mi-database_js"
	],
	"./20px/mi-dollar-circle-solid.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-dollar-circle-solid.js",
		"node_modules_maersk-global_icons_js_20px_mi-dollar-circle-solid_js"
	],
	"./20px/mi-dollar-circle.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-dollar-circle.js",
		"node_modules_maersk-global_icons_js_20px_mi-dollar-circle_js"
	],
	"./20px/mi-door-arrow-right.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-door-arrow-right.js",
		"node_modules_maersk-global_icons_js_20px_mi-door-arrow-right_js"
	],
	"./20px/mi-dot-grid-2x3.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-dot-grid-2x3.js",
		"node_modules_maersk-global_icons_js_20px_mi-dot-grid-2x3_js"
	],
	"./20px/mi-dot-grid-3x2.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-dot-grid-3x2.js",
		"node_modules_maersk-global_icons_js_20px_mi-dot-grid-3x2_js"
	],
	"./20px/mi-dot-grid.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-dot-grid.js",
		"node_modules_maersk-global_icons_js_20px_mi-dot-grid_js"
	],
	"./20px/mi-double-chevron-down.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-double-chevron-down.js",
		"node_modules_maersk-global_icons_js_20px_mi-double-chevron-down_js"
	],
	"./20px/mi-double-chevron-left.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-double-chevron-left.js",
		"node_modules_maersk-global_icons_js_20px_mi-double-chevron-left_js"
	],
	"./20px/mi-double-chevron-right.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-double-chevron-right.js",
		"node_modules_maersk-global_icons_js_20px_mi-double-chevron-right_js"
	],
	"./20px/mi-double-chevron-up.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-double-chevron-up.js",
		"node_modules_maersk-global_icons_js_20px_mi-double-chevron-up_js"
	],
	"./20px/mi-dress.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-dress.js",
		"node_modules_maersk-global_icons_js_20px_mi-dress_js"
	],
	"./20px/mi-droplet.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-droplet.js",
		"node_modules_maersk-global_icons_js_20px_mi-droplet_js"
	],
	"./20px/mi-ellipsis-horizontal.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-ellipsis-horizontal.js",
		"node_modules_maersk-global_icons_js_20px_mi-ellipsis-horizontal_js"
	],
	"./20px/mi-ellipsis-vertical.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-ellipsis-vertical.js",
		"node_modules_maersk-global_icons_js_20px_mi-ellipsis-vertical_js"
	],
	"./20px/mi-emergency-light.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-emergency-light.js",
		"node_modules_maersk-global_icons_js_20px_mi-emergency-light_js"
	],
	"./20px/mi-engine.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-engine.js",
		"node_modules_maersk-global_icons_js_20px_mi-engine_js"
	],
	"./20px/mi-envelope-times-circle.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-envelope-times-circle.js",
		"node_modules_maersk-global_icons_js_20px_mi-envelope-times-circle_js"
	],
	"./20px/mi-envelope.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-envelope.js",
		"node_modules_maersk-global_icons_js_20px_mi-envelope_js"
	],
	"./20px/mi-equal.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-equal.js",
		"node_modules_maersk-global_icons_js_20px_mi-equal_js"
	],
	"./20px/mi-euro-circle.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-euro-circle.js",
		"node_modules_maersk-global_icons_js_20px_mi-euro-circle_js"
	],
	"./20px/mi-exclamation-circle-solid.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-exclamation-circle-solid.js",
		"node_modules_maersk-global_icons_js_20px_mi-exclamation-circle-solid_js"
	],
	"./20px/mi-exclamation-circle.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-exclamation-circle.js",
		"node_modules_maersk-global_icons_js_20px_mi-exclamation-circle_js"
	],
	"./20px/mi-exclamation-octagon-solid.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-exclamation-octagon-solid.js",
		"node_modules_maersk-global_icons_js_20px_mi-exclamation-octagon-solid_js"
	],
	"./20px/mi-exclamation-octagon.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-exclamation-octagon.js",
		"node_modules_maersk-global_icons_js_20px_mi-exclamation-octagon_js"
	],
	"./20px/mi-exclamation-triangle-solid.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-exclamation-triangle-solid.js",
		"node_modules_maersk-global_icons_js_20px_mi-exclamation-triangle-solid_js"
	],
	"./20px/mi-exclamation-triangle.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-exclamation-triangle.js",
		"node_modules_maersk-global_icons_js_20px_mi-exclamation-triangle_js"
	],
	"./20px/mi-expand.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-expand.js",
		"node_modules_maersk-global_icons_js_20px_mi-expand_js"
	],
	"./20px/mi-eye-slash-focus.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-eye-slash-focus.js",
		"node_modules_maersk-global_icons_js_20px_mi-eye-slash-focus_js"
	],
	"./20px/mi-eye-slash.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-eye-slash.js",
		"node_modules_maersk-global_icons_js_20px_mi-eye-slash_js"
	],
	"./20px/mi-eye.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-eye.js",
		"node_modules_maersk-global_icons_js_20px_mi-eye_js"
	],
	"./20px/mi-face-happy-solid.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-face-happy-solid.js",
		"node_modules_maersk-global_icons_js_20px_mi-face-happy-solid_js"
	],
	"./20px/mi-face-happy.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-face-happy.js",
		"node_modules_maersk-global_icons_js_20px_mi-face-happy_js"
	],
	"./20px/mi-face-indifferent-solid.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-face-indifferent-solid.js",
		"node_modules_maersk-global_icons_js_20px_mi-face-indifferent-solid_js"
	],
	"./20px/mi-face-indifferent.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-face-indifferent.js",
		"node_modules_maersk-global_icons_js_20px_mi-face-indifferent_js"
	],
	"./20px/mi-face-sad-solid.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-face-sad-solid.js",
		"node_modules_maersk-global_icons_js_20px_mi-face-sad-solid_js"
	],
	"./20px/mi-face-sad.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-face-sad.js",
		"node_modules_maersk-global_icons_js_20px_mi-face-sad_js"
	],
	"./20px/mi-face-very-happy-solid.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-face-very-happy-solid.js",
		"node_modules_maersk-global_icons_js_20px_mi-face-very-happy-solid_js"
	],
	"./20px/mi-face-very-happy.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-face-very-happy.js",
		"node_modules_maersk-global_icons_js_20px_mi-face-very-happy_js"
	],
	"./20px/mi-face-very-sad-solid.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-face-very-sad-solid.js",
		"node_modules_maersk-global_icons_js_20px_mi-face-very-sad-solid_js"
	],
	"./20px/mi-face-very-sad.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-face-very-sad.js",
		"node_modules_maersk-global_icons_js_20px_mi-face-very-sad_js"
	],
	"./20px/mi-factory.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-factory.js",
		"node_modules_maersk-global_icons_js_20px_mi-factory_js"
	],
	"./20px/mi-file-arrows-square.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-file-arrows-square.js",
		"node_modules_maersk-global_icons_js_20px_mi-file-arrows-square_js"
	],
	"./20px/mi-file-check-stamp.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-file-check-stamp.js",
		"node_modules_maersk-global_icons_js_20px_mi-file-check-stamp_js"
	],
	"./20px/mi-file-check.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-file-check.js",
		"node_modules_maersk-global_icons_js_20px_mi-file-check_js"
	],
	"./20px/mi-file-copy.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-file-copy.js",
		"node_modules_maersk-global_icons_js_20px_mi-file-copy_js"
	],
	"./20px/mi-file-csv.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-file-csv.js",
		"node_modules_maersk-global_icons_js_20px_mi-file-csv_js"
	],
	"./20px/mi-file-excel.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-file-excel.js",
		"node_modules_maersk-global_icons_js_20px_mi-file-excel_js"
	],
	"./20px/mi-file-eye.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-file-eye.js",
		"node_modules_maersk-global_icons_js_20px_mi-file-eye_js"
	],
	"./20px/mi-file-magnifying-glass.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-file-magnifying-glass.js",
		"node_modules_maersk-global_icons_js_20px_mi-file-magnifying-glass_js"
	],
	"./20px/mi-file-other.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-file-other.js",
		"node_modules_maersk-global_icons_js_20px_mi-file-other_js"
	],
	"./20px/mi-file-pdf.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-file-pdf.js",
		"node_modules_maersk-global_icons_js_20px_mi-file-pdf_js"
	],
	"./20px/mi-file-ribbon.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-file-ribbon.js",
		"node_modules_maersk-global_icons_js_20px_mi-file-ribbon_js"
	],
	"./20px/mi-file.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-file.js",
		"node_modules_maersk-global_icons_js_20px_mi-file_js"
	],
	"./20px/mi-fish.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-fish.js",
		"node_modules_maersk-global_icons_js_20px_mi-fish_js"
	],
	"./20px/mi-flag.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-flag.js",
		"node_modules_maersk-global_icons_js_20px_mi-flag_js"
	],
	"./20px/mi-flame.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-flame.js",
		"node_modules_maersk-global_icons_js_20px_mi-flame_js"
	],
	"./20px/mi-floppy-disk.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-floppy-disk.js",
		"node_modules_maersk-global_icons_js_20px_mi-floppy-disk_js"
	],
	"./20px/mi-flow-diagram.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-flow-diagram.js",
		"node_modules_maersk-global_icons_js_20px_mi-flow-diagram_js"
	],
	"./20px/mi-flow.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-flow.js",
		"node_modules_maersk-global_icons_js_20px_mi-flow_js"
	],
	"./20px/mi-folder-arrow-down.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-folder-arrow-down.js",
		"node_modules_maersk-global_icons_js_20px_mi-folder-arrow-down_js"
	],
	"./20px/mi-folder-arrow-up.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-folder-arrow-up.js",
		"node_modules_maersk-global_icons_js_20px_mi-folder-arrow-up_js"
	],
	"./20px/mi-folder-minus.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-folder-minus.js",
		"node_modules_maersk-global_icons_js_20px_mi-folder-minus_js"
	],
	"./20px/mi-folder-open.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-folder-open.js",
		"node_modules_maersk-global_icons_js_20px_mi-folder-open_js"
	],
	"./20px/mi-folder-plus.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-folder-plus.js",
		"node_modules_maersk-global_icons_js_20px_mi-folder-plus_js"
	],
	"./20px/mi-folder-solid.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-folder-solid.js",
		"node_modules_maersk-global_icons_js_20px_mi-folder-solid_js"
	],
	"./20px/mi-folder.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-folder.js",
		"node_modules_maersk-global_icons_js_20px_mi-folder_js"
	],
	"./20px/mi-fuel-pump.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-fuel-pump.js",
		"node_modules_maersk-global_icons_js_20px_mi-fuel-pump_js"
	],
	"./20px/mi-funnel-solid.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-funnel-solid.js",
		"node_modules_maersk-global_icons_js_20px_mi-funnel-solid_js"
	],
	"./20px/mi-funnel.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-funnel.js",
		"node_modules_maersk-global_icons_js_20px_mi-funnel_js"
	],
	"./20px/mi-game-controller.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-game-controller.js",
		"node_modules_maersk-global_icons_js_20px_mi-game-controller_js"
	],
	"./20px/mi-gift.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-gift.js",
		"node_modules_maersk-global_icons_js_20px_mi-gift_js"
	],
	"./20px/mi-globe.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-globe.js",
		"node_modules_maersk-global_icons_js_20px_mi-globe_js"
	],
	"./20px/mi-greater-than-equal.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-greater-than-equal.js",
		"node_modules_maersk-global_icons_js_20px_mi-greater-than-equal_js"
	],
	"./20px/mi-greater-than.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-greater-than.js",
		"node_modules_maersk-global_icons_js_20px_mi-greater-than_js"
	],
	"./20px/mi-grid.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-grid.js",
		"node_modules_maersk-global_icons_js_20px_mi-grid_js"
	],
	"./20px/mi-hair-dryer.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-hair-dryer.js",
		"node_modules_maersk-global_icons_js_20px_mi-hair-dryer_js"
	],
	"./20px/mi-handshake.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-handshake.js",
		"node_modules_maersk-global_icons_js_20px_mi-handshake_js"
	],
	"./20px/mi-headset.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-headset.js",
		"node_modules_maersk-global_icons_js_20px_mi-headset_js"
	],
	"./20px/mi-heart-solid.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-heart-solid.js",
		"node_modules_maersk-global_icons_js_20px_mi-heart-solid_js"
	],
	"./20px/mi-heart.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-heart.js",
		"node_modules_maersk-global_icons_js_20px_mi-heart_js"
	],
	"./20px/mi-high-heel.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-high-heel.js",
		"node_modules_maersk-global_icons_js_20px_mi-high-heel_js"
	],
	"./20px/mi-hook-arrow-left.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-hook-arrow-left.js",
		"node_modules_maersk-global_icons_js_20px_mi-hook-arrow-left_js"
	],
	"./20px/mi-hook-arrow-right.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-hook-arrow-right.js",
		"node_modules_maersk-global_icons_js_20px_mi-hook-arrow-right_js"
	],
	"./20px/mi-house-solid.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-house-solid.js",
		"node_modules_maersk-global_icons_js_20px_mi-house-solid_js"
	],
	"./20px/mi-house.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-house.js",
		"node_modules_maersk-global_icons_js_20px_mi-house_js"
	],
	"./20px/mi-image-polaroid.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-image-polaroid.js",
		"node_modules_maersk-global_icons_js_20px_mi-image-polaroid_js"
	],
	"./20px/mi-image.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-image.js",
		"node_modules_maersk-global_icons_js_20px_mi-image_js"
	],
	"./20px/mi-info-circle-solid.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-info-circle-solid.js",
		"node_modules_maersk-global_icons_js_20px_mi-info-circle-solid_js"
	],
	"./20px/mi-info-circle.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-info-circle.js",
		"node_modules_maersk-global_icons_js_20px_mi-info-circle_js"
	],
	"./20px/mi-jerrycan.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-jerrycan.js",
		"node_modules_maersk-global_icons_js_20px_mi-jerrycan_js"
	],
	"./20px/mi-language.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-language.js",
		"node_modules_maersk-global_icons_js_20px_mi-language_js"
	],
	"./20px/mi-laptop-shopping-cart.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-laptop-shopping-cart.js",
		"node_modules_maersk-global_icons_js_20px_mi-laptop-shopping-cart_js"
	],
	"./20px/mi-laptop.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-laptop.js",
		"node_modules_maersk-global_icons_js_20px_mi-laptop_js"
	],
	"./20px/mi-layout-2x2.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-layout-2x2.js",
		"node_modules_maersk-global_icons_js_20px_mi-layout-2x2_js"
	],
	"./20px/mi-leaf.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-leaf.js",
		"node_modules_maersk-global_icons_js_20px_mi-leaf_js"
	],
	"./20px/mi-lemon-slice.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-lemon-slice.js",
		"node_modules_maersk-global_icons_js_20px_mi-lemon-slice_js"
	],
	"./20px/mi-lemon.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-lemon.js",
		"node_modules_maersk-global_icons_js_20px_mi-lemon_js"
	],
	"./20px/mi-less-than-equal.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-less-than-equal.js",
		"node_modules_maersk-global_icons_js_20px_mi-less-than-equal_js"
	],
	"./20px/mi-less-than.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-less-than.js",
		"node_modules_maersk-global_icons_js_20px_mi-less-than_js"
	],
	"./20px/mi-lifebuoy.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-lifebuoy.js",
		"node_modules_maersk-global_icons_js_20px_mi-lifebuoy_js"
	],
	"./20px/mi-light-bulb.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-light-bulb.js",
		"node_modules_maersk-global_icons_js_20px_mi-light-bulb_js"
	],
	"./20px/mi-lightning.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-lightning.js",
		"node_modules_maersk-global_icons_js_20px_mi-lightning_js"
	],
	"./20px/mi-link.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-link.js",
		"node_modules_maersk-global_icons_js_20px_mi-link_js"
	],
	"./20px/mi-list-bullets.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-list-bullets.js",
		"node_modules_maersk-global_icons_js_20px_mi-list-bullets_js"
	],
	"./20px/mi-list-numbers.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-list-numbers.js",
		"node_modules_maersk-global_icons_js_20px_mi-list-numbers_js"
	],
	"./20px/mi-lock-solid.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-lock-solid.js",
		"node_modules_maersk-global_icons_js_20px_mi-lock-solid_js"
	],
	"./20px/mi-lock-unlocked-solid.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-lock-unlocked-solid.js",
		"node_modules_maersk-global_icons_js_20px_mi-lock-unlocked-solid_js"
	],
	"./20px/mi-lock-unlocked.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-lock-unlocked.js",
		"node_modules_maersk-global_icons_js_20px_mi-lock-unlocked_js"
	],
	"./20px/mi-lock.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-lock.js",
		"node_modules_maersk-global_icons_js_20px_mi-lock_js"
	],
	"./20px/mi-magnifying-glass.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-magnifying-glass.js",
		"node_modules_maersk-global_icons_js_20px_mi-magnifying-glass_js"
	],
	"./20px/mi-man.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-man.js",
		"node_modules_maersk-global_icons_js_20px_mi-man_js"
	],
	"./20px/mi-map.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-map.js",
		"node_modules_maersk-global_icons_js_20px_mi-map_js"
	],
	"./20px/mi-medal.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-medal.js",
		"node_modules_maersk-global_icons_js_20px_mi-medal_js"
	],
	"./20px/mi-medicine-bottle.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-medicine-bottle.js",
		"node_modules_maersk-global_icons_js_20px_mi-medicine-bottle_js"
	],
	"./20px/mi-megaphone.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-megaphone.js",
		"node_modules_maersk-global_icons_js_20px_mi-megaphone_js"
	],
	"./20px/mi-microphone-off.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-microphone-off.js",
		"node_modules_maersk-global_icons_js_20px_mi-microphone-off_js"
	],
	"./20px/mi-microphone.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-microphone.js",
		"node_modules_maersk-global_icons_js_20px_mi-microphone_js"
	],
	"./20px/mi-minus-circle-solid.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-minus-circle-solid.js",
		"node_modules_maersk-global_icons_js_20px_mi-minus-circle-solid_js"
	],
	"./20px/mi-minus-circle.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-minus-circle.js",
		"node_modules_maersk-global_icons_js_20px_mi-minus-circle_js"
	],
	"./20px/mi-minus.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-minus.js",
		"node_modules_maersk-global_icons_js_20px_mi-minus_js"
	],
	"./20px/mi-mobile-phone.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-mobile-phone.js",
		"node_modules_maersk-global_icons_js_20px_mi-mobile-phone_js"
	],
	"./20px/mi-module-1.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-module-1.js",
		"node_modules_maersk-global_icons_js_20px_mi-module-1_js"
	],
	"./20px/mi-module-2.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-module-2.js",
		"node_modules_maersk-global_icons_js_20px_mi-module-2_js"
	],
	"./20px/mi-monitor.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-monitor.js",
		"node_modules_maersk-global_icons_js_20px_mi-monitor_js"
	],
	"./20px/mi-moon-solid.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-moon-solid.js",
		"node_modules_maersk-global_icons_js_20px_mi-moon-solid_js"
	],
	"./20px/mi-moon.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-moon.js",
		"node_modules_maersk-global_icons_js_20px_mi-moon_js"
	],
	"./20px/mi-mouse.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-mouse.js",
		"node_modules_maersk-global_icons_js_20px_mi-mouse_js"
	],
	"./20px/mi-navigation-arrow-up-right.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-navigation-arrow-up-right.js",
		"node_modules_maersk-global_icons_js_20px_mi-navigation-arrow-up-right_js"
	],
	"./20px/mi-navigation-arrow-up.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-navigation-arrow-up.js",
		"node_modules_maersk-global_icons_js_20px_mi-navigation-arrow-up_js"
	],
	"./20px/mi-newspaper.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-newspaper.js",
		"node_modules_maersk-global_icons_js_20px_mi-newspaper_js"
	],
	"./20px/mi-next-circle.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-next-circle.js",
		"node_modules_maersk-global_icons_js_20px_mi-next-circle_js"
	],
	"./20px/mi-next.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-next.js",
		"node_modules_maersk-global_icons_js_20px_mi-next_js"
	],
	"./20px/mi-not-equal.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-not-equal.js",
		"node_modules_maersk-global_icons_js_20px_mi-not-equal_js"
	],
	"./20px/mi-office-1.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-office-1.js",
		"node_modules_maersk-global_icons_js_20px_mi-office-1_js"
	],
	"./20px/mi-office-2.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-office-2.js",
		"node_modules_maersk-global_icons_js_20px_mi-office-2_js"
	],
	"./20px/mi-oil-well.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-oil-well.js",
		"node_modules_maersk-global_icons_js_20px_mi-oil-well_js"
	],
	"./20px/mi-org-chart.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-org-chart.js",
		"node_modules_maersk-global_icons_js_20px_mi-org-chart_js"
	],
	"./20px/mi-oven.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-oven.js",
		"node_modules_maersk-global_icons_js_20px_mi-oven_js"
	],
	"./20px/mi-package-door.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-package-door.js",
		"node_modules_maersk-global_icons_js_20px_mi-package-door_js"
	],
	"./20px/mi-package-open.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-package-open.js",
		"node_modules_maersk-global_icons_js_20px_mi-package-open_js"
	],
	"./20px/mi-package.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-package.js",
		"node_modules_maersk-global_icons_js_20px_mi-package_js"
	],
	"./20px/mi-pallet-empty.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-pallet-empty.js",
		"node_modules_maersk-global_icons_js_20px_mi-pallet-empty_js"
	],
	"./20px/mi-pallet.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-pallet.js",
		"node_modules_maersk-global_icons_js_20px_mi-pallet_js"
	],
	"./20px/mi-paper-plane.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-paper-plane.js",
		"node_modules_maersk-global_icons_js_20px_mi-paper-plane_js"
	],
	"./20px/mi-paperclip.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-paperclip.js",
		"node_modules_maersk-global_icons_js_20px_mi-paperclip_js"
	],
	"./20px/mi-pause-circle.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-pause-circle.js",
		"node_modules_maersk-global_icons_js_20px_mi-pause-circle_js"
	],
	"./20px/mi-pause.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-pause.js",
		"node_modules_maersk-global_icons_js_20px_mi-pause_js"
	],
	"./20px/mi-pencil.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-pencil.js",
		"node_modules_maersk-global_icons_js_20px_mi-pencil_js"
	],
	"./20px/mi-people.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-people.js",
		"node_modules_maersk-global_icons_js_20px_mi-people_js"
	],
	"./20px/mi-person-side-hand.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-person-side-hand.js",
		"node_modules_maersk-global_icons_js_20px_mi-person-side-hand_js"
	],
	"./20px/mi-person.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-person.js",
		"node_modules_maersk-global_icons_js_20px_mi-person_js"
	],
	"./20px/mi-phone-call.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-phone-call.js",
		"node_modules_maersk-global_icons_js_20px_mi-phone-call_js"
	],
	"./20px/mi-phone.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-phone.js",
		"node_modules_maersk-global_icons_js_20px_mi-phone_js"
	],
	"./20px/mi-pig-head.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-pig-head.js",
		"node_modules_maersk-global_icons_js_20px_mi-pig-head_js"
	],
	"./20px/mi-pig-side.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-pig-side.js",
		"node_modules_maersk-global_icons_js_20px_mi-pig-side_js"
	],
	"./20px/mi-pill.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-pill.js",
		"node_modules_maersk-global_icons_js_20px_mi-pill_js"
	],
	"./20px/mi-pin-slash.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-pin-slash.js",
		"node_modules_maersk-global_icons_js_20px_mi-pin-slash_js"
	],
	"./20px/mi-pin-solid.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-pin-solid.js",
		"node_modules_maersk-global_icons_js_20px_mi-pin-solid_js"
	],
	"./20px/mi-pin.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-pin.js",
		"node_modules_maersk-global_icons_js_20px_mi-pin_js"
	],
	"./20px/mi-play-circle.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-play-circle.js",
		"node_modules_maersk-global_icons_js_20px_mi-play-circle_js"
	],
	"./20px/mi-play.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-play.js",
		"node_modules_maersk-global_icons_js_20px_mi-play_js"
	],
	"./20px/mi-plug.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-plug.js",
		"node_modules_maersk-global_icons_js_20px_mi-plug_js"
	],
	"./20px/mi-plus-circle-solid.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-plus-circle-solid.js",
		"node_modules_maersk-global_icons_js_20px_mi-plus-circle-solid_js"
	],
	"./20px/mi-plus-circle.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-plus-circle.js",
		"node_modules_maersk-global_icons_js_20px_mi-plus-circle_js"
	],
	"./20px/mi-plus.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-plus.js",
		"node_modules_maersk-global_icons_js_20px_mi-plus_js"
	],
	"./20px/mi-power.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-power.js",
		"node_modules_maersk-global_icons_js_20px_mi-power_js"
	],
	"./20px/mi-previous-circle.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-previous-circle.js",
		"node_modules_maersk-global_icons_js_20px_mi-previous-circle_js"
	],
	"./20px/mi-previous.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-previous.js",
		"node_modules_maersk-global_icons_js_20px_mi-previous_js"
	],
	"./20px/mi-printer.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-printer.js",
		"node_modules_maersk-global_icons_js_20px_mi-printer_js"
	],
	"./20px/mi-propellor.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-propellor.js",
		"node_modules_maersk-global_icons_js_20px_mi-propellor_js"
	],
	"./20px/mi-push-pin-slash.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-push-pin-slash.js",
		"node_modules_maersk-global_icons_js_20px_mi-push-pin-slash_js"
	],
	"./20px/mi-push-pin.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-push-pin.js",
		"node_modules_maersk-global_icons_js_20px_mi-push-pin_js"
	],
	"./20px/mi-puzzle-piece.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-puzzle-piece.js",
		"node_modules_maersk-global_icons_js_20px_mi-puzzle-piece_js"
	],
	"./20px/mi-qr-code-scan.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-qr-code-scan.js",
		"node_modules_maersk-global_icons_js_20px_mi-qr-code-scan_js"
	],
	"./20px/mi-qr-code.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-qr-code.js",
		"node_modules_maersk-global_icons_js_20px_mi-qr-code_js"
	],
	"./20px/mi-question-circle-solid.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-question-circle-solid.js",
		"node_modules_maersk-global_icons_js_20px_mi-question-circle-solid_js"
	],
	"./20px/mi-question-circle.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-question-circle.js",
		"node_modules_maersk-global_icons_js_20px_mi-question-circle_js"
	],
	"./20px/mi-quote.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-quote.js",
		"node_modules_maersk-global_icons_js_20px_mi-quote_js"
	],
	"./20px/mi-rack.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-rack.js",
		"node_modules_maersk-global_icons_js_20px_mi-rack_js"
	],
	"./20px/mi-radar.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-radar.js",
		"node_modules_maersk-global_icons_js_20px_mi-radar_js"
	],
	"./20px/mi-radio-tower.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-radio-tower.js",
		"node_modules_maersk-global_icons_js_20px_mi-radio-tower_js"
	],
	"./20px/mi-radio.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-radio.js",
		"node_modules_maersk-global_icons_js_20px_mi-radio_js"
	],
	"./20px/mi-receipt.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-receipt.js",
		"node_modules_maersk-global_icons_js_20px_mi-receipt_js"
	],
	"./20px/mi-rectangle.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-rectangle.js",
		"node_modules_maersk-global_icons_js_20px_mi-rectangle_js"
	],
	"./20px/mi-remote-control-hand.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-remote-control-hand.js",
		"node_modules_maersk-global_icons_js_20px_mi-remote-control-hand_js"
	],
	"./20px/mi-remote-control.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-remote-control.js",
		"node_modules_maersk-global_icons_js_20px_mi-remote-control_js"
	],
	"./20px/mi-rotate.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-rotate.js",
		"node_modules_maersk-global_icons_js_20px_mi-rotate_js"
	],
	"./20px/mi-route-network.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-route-network.js",
		"node_modules_maersk-global_icons_js_20px_mi-route-network_js"
	],
	"./20px/mi-route.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-route.js",
		"node_modules_maersk-global_icons_js_20px_mi-route_js"
	],
	"./20px/mi-rubber-tyred-gantry-crane.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-rubber-tyred-gantry-crane.js",
		"node_modules_maersk-global_icons_js_20px_mi-rubber-tyred-gantry-crane_js"
	],
	"./20px/mi-ruler.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-ruler.js",
		"node_modules_maersk-global_icons_js_20px_mi-ruler_js"
	],
	"./20px/mi-safety-gear.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-safety-gear.js",
		"node_modules_maersk-global_icons_js_20px_mi-safety-gear_js"
	],
	"./20px/mi-safety-helmet.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-safety-helmet.js",
		"node_modules_maersk-global_icons_js_20px_mi-safety-helmet_js"
	],
	"./20px/mi-sandbox.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-sandbox.js",
		"node_modules_maersk-global_icons_js_20px_mi-sandbox_js"
	],
	"./20px/mi-scale-balance.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-scale-balance.js",
		"node_modules_maersk-global_icons_js_20px_mi-scale-balance_js"
	],
	"./20px/mi-scale.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-scale.js",
		"node_modules_maersk-global_icons_js_20px_mi-scale_js"
	],
	"./20px/mi-scissors.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-scissors.js",
		"node_modules_maersk-global_icons_js_20px_mi-scissors_js"
	],
	"./20px/mi-shapes.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-shapes.js",
		"node_modules_maersk-global_icons_js_20px_mi-shapes_js"
	],
	"./20px/mi-share.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-share.js",
		"node_modules_maersk-global_icons_js_20px_mi-share_js"
	],
	"./20px/mi-shield-check.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-shield-check.js",
		"node_modules_maersk-global_icons_js_20px_mi-shield-check_js"
	],
	"./20px/mi-shield-key.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-shield-key.js",
		"node_modules_maersk-global_icons_js_20px_mi-shield-key_js"
	],
	"./20px/mi-shield-lock.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-shield-lock.js",
		"node_modules_maersk-global_icons_js_20px_mi-shield-lock_js"
	],
	"./20px/mi-shield.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-shield.js",
		"node_modules_maersk-global_icons_js_20px_mi-shield_js"
	],
	"./20px/mi-shoe.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-shoe.js",
		"node_modules_maersk-global_icons_js_20px_mi-shoe_js"
	],
	"./20px/mi-shopping-cart-return.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-shopping-cart-return.js",
		"node_modules_maersk-global_icons_js_20px_mi-shopping-cart-return_js"
	],
	"./20px/mi-shopping-cart.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-shopping-cart.js",
		"node_modules_maersk-global_icons_js_20px_mi-shopping-cart_js"
	],
	"./20px/mi-shrimp.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-shrimp.js",
		"node_modules_maersk-global_icons_js_20px_mi-shrimp_js"
	],
	"./20px/mi-shrink.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-shrink.js",
		"node_modules_maersk-global_icons_js_20px_mi-shrink_js"
	],
	"./20px/mi-shuttle-carrier.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-shuttle-carrier.js",
		"node_modules_maersk-global_icons_js_20px_mi-shuttle-carrier_js"
	],
	"./20px/mi-sidebar-left-arrow-left.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-sidebar-left-arrow-left.js",
		"node_modules_maersk-global_icons_js_20px_mi-sidebar-left-arrow-left_js"
	],
	"./20px/mi-sidebar-left-arrow-right.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-sidebar-left-arrow-right.js",
		"node_modules_maersk-global_icons_js_20px_mi-sidebar-left-arrow-right_js"
	],
	"./20px/mi-sidebar-right-arrow-right.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-sidebar-right-arrow-right.js",
		"node_modules_maersk-global_icons_js_20px_mi-sidebar-right-arrow-right_js"
	],
	"./20px/mi-signpost.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-signpost.js",
		"node_modules_maersk-global_icons_js_20px_mi-signpost_js"
	],
	"./20px/mi-sliders-horizontal.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-sliders-horizontal.js",
		"node_modules_maersk-global_icons_js_20px_mi-sliders-horizontal_js"
	],
	"./20px/mi-sliders-vertical.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-sliders-vertical.js",
		"node_modules_maersk-global_icons_js_20px_mi-sliders-vertical_js"
	],
	"./20px/mi-snowflake.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-snowflake.js",
		"node_modules_maersk-global_icons_js_20px_mi-snowflake_js"
	],
	"./20px/mi-socks.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-socks.js",
		"node_modules_maersk-global_icons_js_20px_mi-socks_js"
	],
	"./20px/mi-sparkle.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-sparkle.js",
		"node_modules_maersk-global_icons_js_20px_mi-sparkle_js"
	],
	"./20px/mi-speaker-high-volume.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-speaker-high-volume.js",
		"node_modules_maersk-global_icons_js_20px_mi-speaker-high-volume_js"
	],
	"./20px/mi-speaker-low-volume.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-speaker-low-volume.js",
		"node_modules_maersk-global_icons_js_20px_mi-speaker-low-volume_js"
	],
	"./20px/mi-speaker-mute.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-speaker-mute.js",
		"node_modules_maersk-global_icons_js_20px_mi-speaker-mute_js"
	],
	"./20px/mi-speedometer.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-speedometer.js",
		"node_modules_maersk-global_icons_js_20px_mi-speedometer_js"
	],
	"./20px/mi-square-arrow-up-right.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-square-arrow-up-right.js",
		"node_modules_maersk-global_icons_js_20px_mi-square-arrow-up-right_js"
	],
	"./20px/mi-square-arrow-up.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-square-arrow-up.js",
		"node_modules_maersk-global_icons_js_20px_mi-square-arrow-up_js"
	],
	"./20px/mi-square.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-square.js",
		"node_modules_maersk-global_icons_js_20px_mi-square_js"
	],
	"./20px/mi-stack.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-stack.js",
		"node_modules_maersk-global_icons_js_20px_mi-stack_js"
	],
	"./20px/mi-stamp.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-stamp.js",
		"node_modules_maersk-global_icons_js_20px_mi-stamp_js"
	],
	"./20px/mi-star-solid.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-star-solid.js",
		"node_modules_maersk-global_icons_js_20px_mi-star-solid_js"
	],
	"./20px/mi-star.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-star.js",
		"node_modules_maersk-global_icons_js_20px_mi-star_js"
	],
	"./20px/mi-steering-wheel.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-steering-wheel.js",
		"node_modules_maersk-global_icons_js_20px_mi-steering-wheel_js"
	],
	"./20px/mi-stop-circle.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-stop-circle.js",
		"node_modules_maersk-global_icons_js_20px_mi-stop-circle_js"
	],
	"./20px/mi-stop.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-stop.js",
		"node_modules_maersk-global_icons_js_20px_mi-stop_js"
	],
	"./20px/mi-store.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-store.js",
		"node_modules_maersk-global_icons_js_20px_mi-store_js"
	],
	"./20px/mi-sun-solid.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-sun-solid.js",
		"node_modules_maersk-global_icons_js_20px_mi-sun-solid_js"
	],
	"./20px/mi-sun.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-sun.js",
		"node_modules_maersk-global_icons_js_20px_mi-sun_js"
	],
	"./20px/mi-sustainability.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-sustainability.js",
		"node_modules_maersk-global_icons_js_20px_mi-sustainability_js"
	],
	"./20px/mi-t-shirt.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-t-shirt.js",
		"node_modules_maersk-global_icons_js_20px_mi-t-shirt_js"
	],
	"./20px/mi-table.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-table.js",
		"node_modules_maersk-global_icons_js_20px_mi-table_js"
	],
	"./20px/mi-tablet.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-tablet.js",
		"node_modules_maersk-global_icons_js_20px_mi-tablet_js"
	],
	"./20px/mi-tachometer.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-tachometer.js",
		"node_modules_maersk-global_icons_js_20px_mi-tachometer_js"
	],
	"./20px/mi-tag.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-tag.js",
		"node_modules_maersk-global_icons_js_20px_mi-tag_js"
	],
	"./20px/mi-television.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-television.js",
		"node_modules_maersk-global_icons_js_20px_mi-television_js"
	],
	"./20px/mi-text.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-text.js",
		"node_modules_maersk-global_icons_js_20px_mi-text_js"
	],
	"./20px/mi-thermometer-minus.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-thermometer-minus.js",
		"node_modules_maersk-global_icons_js_20px_mi-thermometer-minus_js"
	],
	"./20px/mi-thermometer-plus.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-thermometer-plus.js",
		"node_modules_maersk-global_icons_js_20px_mi-thermometer-plus_js"
	],
	"./20px/mi-thermometer-snow.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-thermometer-snow.js",
		"node_modules_maersk-global_icons_js_20px_mi-thermometer-snow_js"
	],
	"./20px/mi-thermometer-sun.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-thermometer-sun.js",
		"node_modules_maersk-global_icons_js_20px_mi-thermometer-sun_js"
	],
	"./20px/mi-thermometer.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-thermometer.js",
		"node_modules_maersk-global_icons_js_20px_mi-thermometer_js"
	],
	"./20px/mi-thumbs-down-solid.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-thumbs-down-solid.js",
		"node_modules_maersk-global_icons_js_20px_mi-thumbs-down-solid_js"
	],
	"./20px/mi-thumbs-down.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-thumbs-down.js",
		"node_modules_maersk-global_icons_js_20px_mi-thumbs-down_js"
	],
	"./20px/mi-thumbs-up-solid.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-thumbs-up-solid.js",
		"node_modules_maersk-global_icons_js_20px_mi-thumbs-up-solid_js"
	],
	"./20px/mi-thumbs-up.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-thumbs-up.js",
		"node_modules_maersk-global_icons_js_20px_mi-thumbs-up_js"
	],
	"./20px/mi-times-circle-solid.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-times-circle-solid.js",
		"node_modules_maersk-global_icons_js_20px_mi-times-circle-solid_js"
	],
	"./20px/mi-times-circle.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-times-circle.js",
		"node_modules_maersk-global_icons_js_20px_mi-times-circle_js"
	],
	"./20px/mi-times.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-times.js",
		"node_modules_maersk-global_icons_js_20px_mi-times_js"
	],
	"./20px/mi-tire.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-tire.js",
		"node_modules_maersk-global_icons_js_20px_mi-tire_js"
	],
	"./20px/mi-train-front.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-train-front.js",
		"node_modules_maersk-global_icons_js_20px_mi-train-front_js"
	],
	"./20px/mi-trash.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-trash.js",
		"node_modules_maersk-global_icons_js_20px_mi-trash_js"
	],
	"./20px/mi-tray-arrow-down.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-tray-arrow-down.js",
		"node_modules_maersk-global_icons_js_20px_mi-tray-arrow-down_js"
	],
	"./20px/mi-tray-arrow-up.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-tray-arrow-up.js",
		"node_modules_maersk-global_icons_js_20px_mi-tray-arrow-up_js"
	],
	"./20px/mi-truck-front-clock.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-truck-front-clock.js",
		"node_modules_maersk-global_icons_js_20px_mi-truck-front-clock_js"
	],
	"./20px/mi-truck-front-pause-circle.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-truck-front-pause-circle.js",
		"node_modules_maersk-global_icons_js_20px_mi-truck-front-pause-circle_js"
	],
	"./20px/mi-truck-front.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-truck-front.js",
		"node_modules_maersk-global_icons_js_20px_mi-truck-front_js"
	],
	"./20px/mi-truck-side-reefer.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-truck-side-reefer.js",
		"node_modules_maersk-global_icons_js_20px_mi-truck-side-reefer_js"
	],
	"./20px/mi-truck-side.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-truck-side.js",
		"node_modules_maersk-global_icons_js_20px_mi-truck-side_js"
	],
	"./20px/mi-tugboat-side.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-tugboat-side.js",
		"node_modules_maersk-global_icons_js_20px_mi-tugboat-side_js"
	],
	"./20px/mi-turnip.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-turnip.js",
		"node_modules_maersk-global_icons_js_20px_mi-turnip_js"
	],
	"./20px/mi-twistlock.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-twistlock.js",
		"node_modules_maersk-global_icons_js_20px_mi-twistlock_js"
	],
	"./20px/mi-user-circle-solid.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-user-circle-solid.js",
		"node_modules_maersk-global_icons_js_20px_mi-user-circle-solid_js"
	],
	"./20px/mi-user-circle.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-user-circle.js",
		"node_modules_maersk-global_icons_js_20px_mi-user-circle_js"
	],
	"./20px/mi-user-cog.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-user-cog.js",
		"node_modules_maersk-global_icons_js_20px_mi-user-cog_js"
	],
	"./20px/mi-user-key.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-user-key.js",
		"node_modules_maersk-global_icons_js_20px_mi-user-key_js"
	],
	"./20px/mi-user-plus-circle.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-user-plus-circle.js",
		"node_modules_maersk-global_icons_js_20px_mi-user-plus-circle_js"
	],
	"./20px/mi-user-solid.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-user-solid.js",
		"node_modules_maersk-global_icons_js_20px_mi-user-solid_js"
	],
	"./20px/mi-user-text-rectangle.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-user-text-rectangle.js",
		"node_modules_maersk-global_icons_js_20px_mi-user-text-rectangle_js"
	],
	"./20px/mi-user.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-user.js",
		"node_modules_maersk-global_icons_js_20px_mi-user_js"
	],
	"./20px/mi-users-solid.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-users-solid.js",
		"node_modules_maersk-global_icons_js_20px_mi-users-solid_js"
	],
	"./20px/mi-users.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-users.js",
		"node_modules_maersk-global_icons_js_20px_mi-users_js"
	],
	"./20px/mi-vessel-front.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-vessel-front.js",
		"node_modules_maersk-global_icons_js_20px_mi-vessel-front_js"
	],
	"./20px/mi-vessel-side-arrow-down-up.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-vessel-side-arrow-down-up.js",
		"node_modules_maersk-global_icons_js_20px_mi-vessel-side-arrow-down-up_js"
	],
	"./20px/mi-vessel-side-arrow-down.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-vessel-side-arrow-down.js",
		"node_modules_maersk-global_icons_js_20px_mi-vessel-side-arrow-down_js"
	],
	"./20px/mi-vessel-side-arrow-up.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-vessel-side-arrow-up.js",
		"node_modules_maersk-global_icons_js_20px_mi-vessel-side-arrow-up_js"
	],
	"./20px/mi-vessel-side.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-vessel-side.js",
		"node_modules_maersk-global_icons_js_20px_mi-vessel-side_js"
	],
	"./20px/mi-video-clapperboard.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-video-clapperboard.js",
		"node_modules_maersk-global_icons_js_20px_mi-video-clapperboard_js"
	],
	"./20px/mi-video.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-video.js",
		"node_modules_maersk-global_icons_js_20px_mi-video_js"
	],
	"./20px/mi-warehouse-reefer.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-warehouse-reefer.js",
		"node_modules_maersk-global_icons_js_20px_mi-warehouse-reefer_js"
	],
	"./20px/mi-warehouse.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-warehouse.js",
		"node_modules_maersk-global_icons_js_20px_mi-warehouse_js"
	],
	"./20px/mi-webhook.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-webhook.js",
		"node_modules_maersk-global_icons_js_20px_mi-webhook_js"
	],
	"./20px/mi-wifi-offline.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-wifi-offline.js",
		"node_modules_maersk-global_icons_js_20px_mi-wifi-offline_js"
	],
	"./20px/mi-wifi.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-wifi.js",
		"node_modules_maersk-global_icons_js_20px_mi-wifi_js"
	],
	"./20px/mi-wrench.js": [
		"./node_modules/@maersk-global/icons/js/20px/mi-wrench.js",
		"node_modules_maersk-global_icons_js_20px_mi-wrench_js"
	],
	"./24px/mi-airplane-arrival.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-airplane-arrival.js",
		"node_modules_maersk-global_icons_js_24px_mi-airplane-arrival_js"
	],
	"./24px/mi-airplane-departure.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-airplane-departure.js",
		"node_modules_maersk-global_icons_js_24px_mi-airplane-departure_js"
	],
	"./24px/mi-airplane.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-airplane.js",
		"node_modules_maersk-global_icons_js_24px_mi-airplane_js"
	],
	"./24px/mi-anchor.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-anchor.js",
		"node_modules_maersk-global_icons_js_24px_mi-anchor_js"
	],
	"./24px/mi-apple-alt.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-apple-alt.js",
		"node_modules_maersk-global_icons_js_24px_mi-apple-alt_js"
	],
	"./24px/mi-apple.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-apple.js",
		"node_modules_maersk-global_icons_js_24px_mi-apple_js"
	],
	"./24px/mi-arrow-all-directions.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-arrow-all-directions.js",
		"node_modules_maersk-global_icons_js_24px_mi-arrow-all-directions_js"
	],
	"./24px/mi-arrow-anti-clockwise-clock.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-arrow-anti-clockwise-clock.js",
		"node_modules_maersk-global_icons_js_24px_mi-arrow-anti-clockwise-clock_js"
	],
	"./24px/mi-arrow-anti-clockwise.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-arrow-anti-clockwise.js",
		"node_modules_maersk-global_icons_js_24px_mi-arrow-anti-clockwise_js"
	],
	"./24px/mi-arrow-clockwise-clock.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-arrow-clockwise-clock.js",
		"node_modules_maersk-global_icons_js_24px_mi-arrow-clockwise-clock_js"
	],
	"./24px/mi-arrow-clockwise-times.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-arrow-clockwise-times.js",
		"node_modules_maersk-global_icons_js_24px_mi-arrow-clockwise-times_js"
	],
	"./24px/mi-arrow-clockwise.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-arrow-clockwise.js",
		"node_modules_maersk-global_icons_js_24px_mi-arrow-clockwise_js"
	],
	"./24px/mi-arrow-curved-up-left.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-arrow-curved-up-left.js",
		"node_modules_maersk-global_icons_js_24px_mi-arrow-curved-up-left_js"
	],
	"./24px/mi-arrow-curved-up-right.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-arrow-curved-up-right.js",
		"node_modules_maersk-global_icons_js_24px_mi-arrow-curved-up-right_js"
	],
	"./24px/mi-arrow-down-circle.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-arrow-down-circle.js",
		"node_modules_maersk-global_icons_js_24px_mi-arrow-down-circle_js"
	],
	"./24px/mi-arrow-down-left.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-arrow-down-left.js",
		"node_modules_maersk-global_icons_js_24px_mi-arrow-down-left_js"
	],
	"./24px/mi-arrow-down-right.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-arrow-down-right.js",
		"node_modules_maersk-global_icons_js_24px_mi-arrow-down-right_js"
	],
	"./24px/mi-arrow-down-square-dashed.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-arrow-down-square-dashed.js",
		"node_modules_maersk-global_icons_js_24px_mi-arrow-down-square-dashed_js"
	],
	"./24px/mi-arrow-down-square.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-arrow-down-square.js",
		"node_modules_maersk-global_icons_js_24px_mi-arrow-down-square_js"
	],
	"./24px/mi-arrow-down.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-arrow-down.js",
		"node_modules_maersk-global_icons_js_24px_mi-arrow-down_js"
	],
	"./24px/mi-arrow-from-bottom.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-arrow-from-bottom.js",
		"node_modules_maersk-global_icons_js_24px_mi-arrow-from-bottom_js"
	],
	"./24px/mi-arrow-from-left.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-arrow-from-left.js",
		"node_modules_maersk-global_icons_js_24px_mi-arrow-from-left_js"
	],
	"./24px/mi-arrow-from-right.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-arrow-from-right.js",
		"node_modules_maersk-global_icons_js_24px_mi-arrow-from-right_js"
	],
	"./24px/mi-arrow-from-top.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-arrow-from-top.js",
		"node_modules_maersk-global_icons_js_24px_mi-arrow-from-top_js"
	],
	"./24px/mi-arrow-left-circle.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-arrow-left-circle.js",
		"node_modules_maersk-global_icons_js_24px_mi-arrow-left-circle_js"
	],
	"./24px/mi-arrow-left.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-arrow-left.js",
		"node_modules_maersk-global_icons_js_24px_mi-arrow-left_js"
	],
	"./24px/mi-arrow-right-circle.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-arrow-right-circle.js",
		"node_modules_maersk-global_icons_js_24px_mi-arrow-right-circle_js"
	],
	"./24px/mi-arrow-right.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-arrow-right.js",
		"node_modules_maersk-global_icons_js_24px_mi-arrow-right_js"
	],
	"./24px/mi-arrow-to-bottom.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-arrow-to-bottom.js",
		"node_modules_maersk-global_icons_js_24px_mi-arrow-to-bottom_js"
	],
	"./24px/mi-arrow-to-left.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-arrow-to-left.js",
		"node_modules_maersk-global_icons_js_24px_mi-arrow-to-left_js"
	],
	"./24px/mi-arrow-to-right.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-arrow-to-right.js",
		"node_modules_maersk-global_icons_js_24px_mi-arrow-to-right_js"
	],
	"./24px/mi-arrow-to-top.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-arrow-to-top.js",
		"node_modules_maersk-global_icons_js_24px_mi-arrow-to-top_js"
	],
	"./24px/mi-arrow-up-circle.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-arrow-up-circle.js",
		"node_modules_maersk-global_icons_js_24px_mi-arrow-up-circle_js"
	],
	"./24px/mi-arrow-up-left.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-arrow-up-left.js",
		"node_modules_maersk-global_icons_js_24px_mi-arrow-up-left_js"
	],
	"./24px/mi-arrow-up-merge.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-arrow-up-merge.js",
		"node_modules_maersk-global_icons_js_24px_mi-arrow-up-merge_js"
	],
	"./24px/mi-arrow-up-right.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-arrow-up-right.js",
		"node_modules_maersk-global_icons_js_24px_mi-arrow-up-right_js"
	],
	"./24px/mi-arrow-up-square-dashed.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-arrow-up-square-dashed.js",
		"node_modules_maersk-global_icons_js_24px_mi-arrow-up-square-dashed_js"
	],
	"./24px/mi-arrow-up-square.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-arrow-up-square.js",
		"node_modules_maersk-global_icons_js_24px_mi-arrow-up-square_js"
	],
	"./24px/mi-arrow-up.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-arrow-up.js",
		"node_modules_maersk-global_icons_js_24px_mi-arrow-up_js"
	],
	"./24px/mi-arrows-down-up.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-arrows-down-up.js",
		"node_modules_maersk-global_icons_js_24px_mi-arrows-down-up_js"
	],
	"./24px/mi-arrows-left-line-right.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-arrows-left-line-right.js",
		"node_modules_maersk-global_icons_js_24px_mi-arrows-left-line-right_js"
	],
	"./24px/mi-arrows-left-right.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-arrows-left-right.js",
		"node_modules_maersk-global_icons_js_24px_mi-arrows-left-right_js"
	],
	"./24px/mi-arrows-right-line-left.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-arrows-right-line-left.js",
		"node_modules_maersk-global_icons_js_24px_mi-arrows-right-line-left_js"
	],
	"./24px/mi-banana.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-banana.js",
		"node_modules_maersk-global_icons_js_24px_mi-banana_js"
	],
	"./24px/mi-barcode-scan.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-barcode-scan.js",
		"node_modules_maersk-global_icons_js_24px_mi-barcode-scan_js"
	],
	"./24px/mi-barcode.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-barcode.js",
		"node_modules_maersk-global_icons_js_24px_mi-barcode_js"
	],
	"./24px/mi-barrel.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-barrel.js",
		"node_modules_maersk-global_icons_js_24px_mi-barrel_js"
	],
	"./24px/mi-bars-horizontal-bullets.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-bars-horizontal-bullets.js",
		"node_modules_maersk-global_icons_js_24px_mi-bars-horizontal-bullets_js"
	],
	"./24px/mi-bars-horizontal-funnel-down.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-bars-horizontal-funnel-down.js",
		"node_modules_maersk-global_icons_js_24px_mi-bars-horizontal-funnel-down_js"
	],
	"./24px/mi-bars-horizontal-funnel-left.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-bars-horizontal-funnel-left.js",
		"node_modules_maersk-global_icons_js_24px_mi-bars-horizontal-funnel-left_js"
	],
	"./24px/mi-bars-horizontal.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-bars-horizontal.js",
		"node_modules_maersk-global_icons_js_24px_mi-bars-horizontal_js"
	],
	"./24px/mi-battery-bolt.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-battery-bolt.js",
		"node_modules_maersk-global_icons_js_24px_mi-battery-bolt_js"
	],
	"./24px/mi-battery-solid.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-battery-solid.js",
		"node_modules_maersk-global_icons_js_24px_mi-battery-solid_js"
	],
	"./24px/mi-battery.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-battery.js",
		"node_modules_maersk-global_icons_js_24px_mi-battery_js"
	],
	"./24px/mi-bell-slash.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-bell-slash.js",
		"node_modules_maersk-global_icons_js_24px_mi-bell-slash_js"
	],
	"./24px/mi-bell-solid.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-bell-solid.js",
		"node_modules_maersk-global_icons_js_24px_mi-bell-solid_js"
	],
	"./24px/mi-bell.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-bell.js",
		"node_modules_maersk-global_icons_js_24px_mi-bell_js"
	],
	"./24px/mi-between.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-between.js",
		"node_modules_maersk-global_icons_js_24px_mi-between_js"
	],
	"./24px/mi-bicycle.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-bicycle.js",
		"node_modules_maersk-global_icons_js_24px_mi-bicycle_js"
	],
	"./24px/mi-binoculars.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-binoculars.js",
		"node_modules_maersk-global_icons_js_24px_mi-binoculars_js"
	],
	"./24px/mi-book-open.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-book-open.js",
		"node_modules_maersk-global_icons_js_24px_mi-book-open_js"
	],
	"./24px/mi-bookmark-solid.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-bookmark-solid.js",
		"node_modules_maersk-global_icons_js_24px_mi-bookmark-solid_js"
	],
	"./24px/mi-bookmark.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-bookmark.js",
		"node_modules_maersk-global_icons_js_24px_mi-bookmark_js"
	],
	"./24px/mi-box.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-box.js",
		"node_modules_maersk-global_icons_js_24px_mi-box_js"
	],
	"./24px/mi-boxes-stacked.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-boxes-stacked.js",
		"node_modules_maersk-global_icons_js_24px_mi-boxes-stacked_js"
	],
	"./24px/mi-briefcase.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-briefcase.js",
		"node_modules_maersk-global_icons_js_24px_mi-briefcase_js"
	],
	"./24px/mi-browser.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-browser.js",
		"node_modules_maersk-global_icons_js_24px_mi-browser_js"
	],
	"./24px/mi-bucket-mop.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-bucket-mop.js",
		"node_modules_maersk-global_icons_js_24px_mi-bucket-mop_js"
	],
	"./24px/mi-bus-side.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-bus-side.js",
		"node_modules_maersk-global_icons_js_24px_mi-bus-side_js"
	],
	"./24px/mi-calculator.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-calculator.js",
		"node_modules_maersk-global_icons_js_24px_mi-calculator_js"
	],
	"./24px/mi-calendar-check.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-calendar-check.js",
		"node_modules_maersk-global_icons_js_24px_mi-calendar-check_js"
	],
	"./24px/mi-calendar-clock.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-calendar-clock.js",
		"node_modules_maersk-global_icons_js_24px_mi-calendar-clock_js"
	],
	"./24px/mi-calendar-exclamation.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-calendar-exclamation.js",
		"node_modules_maersk-global_icons_js_24px_mi-calendar-exclamation_js"
	],
	"./24px/mi-calendar-minus.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-calendar-minus.js",
		"node_modules_maersk-global_icons_js_24px_mi-calendar-minus_js"
	],
	"./24px/mi-calendar-plus.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-calendar-plus.js",
		"node_modules_maersk-global_icons_js_24px_mi-calendar-plus_js"
	],
	"./24px/mi-calendar-times.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-calendar-times.js",
		"node_modules_maersk-global_icons_js_24px_mi-calendar-times_js"
	],
	"./24px/mi-calendar.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-calendar.js",
		"node_modules_maersk-global_icons_js_24px_mi-calendar_js"
	],
	"./24px/mi-camera-cctv.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-camera-cctv.js",
		"node_modules_maersk-global_icons_js_24px_mi-camera-cctv_js"
	],
	"./24px/mi-camera-focus.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-camera-focus.js",
		"node_modules_maersk-global_icons_js_24px_mi-camera-focus_js"
	],
	"./24px/mi-camera.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-camera.js",
		"node_modules_maersk-global_icons_js_24px_mi-camera_js"
	],
	"./24px/mi-captain-hat.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-captain-hat.js",
		"node_modules_maersk-global_icons_js_24px_mi-captain-hat_js"
	],
	"./24px/mi-car-front.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-car-front.js",
		"node_modules_maersk-global_icons_js_24px_mi-car-front_js"
	],
	"./24px/mi-car-side.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-car-side.js",
		"node_modules_maersk-global_icons_js_24px_mi-car-side_js"
	],
	"./24px/mi-caret-down-solid.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-caret-down-solid.js",
		"node_modules_maersk-global_icons_js_24px_mi-caret-down-solid_js"
	],
	"./24px/mi-caret-down.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-caret-down.js",
		"node_modules_maersk-global_icons_js_24px_mi-caret-down_js"
	],
	"./24px/mi-caret-left-solid.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-caret-left-solid.js",
		"node_modules_maersk-global_icons_js_24px_mi-caret-left-solid_js"
	],
	"./24px/mi-caret-left.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-caret-left.js",
		"node_modules_maersk-global_icons_js_24px_mi-caret-left_js"
	],
	"./24px/mi-caret-right-solid.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-caret-right-solid.js",
		"node_modules_maersk-global_icons_js_24px_mi-caret-right-solid_js"
	],
	"./24px/mi-caret-right.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-caret-right.js",
		"node_modules_maersk-global_icons_js_24px_mi-caret-right_js"
	],
	"./24px/mi-caret-up-down-solid.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-caret-up-down-solid.js",
		"node_modules_maersk-global_icons_js_24px_mi-caret-up-down-solid_js"
	],
	"./24px/mi-caret-up-down.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-caret-up-down.js",
		"node_modules_maersk-global_icons_js_24px_mi-caret-up-down_js"
	],
	"./24px/mi-caret-up-solid.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-caret-up-solid.js",
		"node_modules_maersk-global_icons_js_24px_mi-caret-up-solid_js"
	],
	"./24px/mi-caret-up.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-caret-up.js",
		"node_modules_maersk-global_icons_js_24px_mi-caret-up_js"
	],
	"./24px/mi-carrot.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-carrot.js",
		"node_modules_maersk-global_icons_js_24px_mi-carrot_js"
	],
	"./24px/mi-cash.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-cash.js",
		"node_modules_maersk-global_icons_js_24px_mi-cash_js"
	],
	"./24px/mi-chart-arrow-up-right.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-chart-arrow-up-right.js",
		"node_modules_maersk-global_icons_js_24px_mi-chart-arrow-up-right_js"
	],
	"./24px/mi-chart-bars-vertical-stacked.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-chart-bars-vertical-stacked.js",
		"node_modules_maersk-global_icons_js_24px_mi-chart-bars-vertical-stacked_js"
	],
	"./24px/mi-chart-bars-vertical.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-chart-bars-vertical.js",
		"node_modules_maersk-global_icons_js_24px_mi-chart-bars-vertical_js"
	],
	"./24px/mi-chart-donut.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-chart-donut.js",
		"node_modules_maersk-global_icons_js_24px_mi-chart-donut_js"
	],
	"./24px/mi-chart-line-up.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-chart-line-up.js",
		"node_modules_maersk-global_icons_js_24px_mi-chart-line-up_js"
	],
	"./24px/mi-chart-pie.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-chart-pie.js",
		"node_modules_maersk-global_icons_js_24px_mi-chart-pie_js"
	],
	"./24px/mi-chatbot.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-chatbot.js",
		"node_modules_maersk-global_icons_js_24px_mi-chatbot_js"
	],
	"./24px/mi-check-circle-half-dashed.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-check-circle-half-dashed.js",
		"node_modules_maersk-global_icons_js_24px_mi-check-circle-half-dashed_js"
	],
	"./24px/mi-check-circle-solid.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-check-circle-solid.js",
		"node_modules_maersk-global_icons_js_24px_mi-check-circle-solid_js"
	],
	"./24px/mi-check-circle.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-check-circle.js",
		"node_modules_maersk-global_icons_js_24px_mi-check-circle_js"
	],
	"./24px/mi-check-square-copy.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-check-square-copy.js",
		"node_modules_maersk-global_icons_js_24px_mi-check-square-copy_js"
	],
	"./24px/mi-check.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-check.js",
		"node_modules_maersk-global_icons_js_24px_mi-check_js"
	],
	"./24px/mi-chemistry-beakers.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-chemistry-beakers.js",
		"node_modules_maersk-global_icons_js_24px_mi-chemistry-beakers_js"
	],
	"./24px/mi-chevron-down.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-chevron-down.js",
		"node_modules_maersk-global_icons_js_24px_mi-chevron-down_js"
	],
	"./24px/mi-chevron-left.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-chevron-left.js",
		"node_modules_maersk-global_icons_js_24px_mi-chevron-left_js"
	],
	"./24px/mi-chevron-right.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-chevron-right.js",
		"node_modules_maersk-global_icons_js_24px_mi-chevron-right_js"
	],
	"./24px/mi-chevron-up.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-chevron-up.js",
		"node_modules_maersk-global_icons_js_24px_mi-chevron-up_js"
	],
	"./24px/mi-chevrons-left-right.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-chevrons-left-right.js",
		"node_modules_maersk-global_icons_js_24px_mi-chevrons-left-right_js"
	],
	"./24px/mi-chevrons-up-down.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-chevrons-up-down.js",
		"node_modules_maersk-global_icons_js_24px_mi-chevrons-up-down_js"
	],
	"./24px/mi-chicken-drumstick.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-chicken-drumstick.js",
		"node_modules_maersk-global_icons_js_24px_mi-chicken-drumstick_js"
	],
	"./24px/mi-chicken-head.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-chicken-head.js",
		"node_modules_maersk-global_icons_js_24px_mi-chicken-head_js"
	],
	"./24px/mi-chicken-side.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-chicken-side.js",
		"node_modules_maersk-global_icons_js_24px_mi-chicken-side_js"
	],
	"./24px/mi-chip.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-chip.js",
		"node_modules_maersk-global_icons_js_24px_mi-chip_js"
	],
	"./24px/mi-circle-slash.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-circle-slash.js",
		"node_modules_maersk-global_icons_js_24px_mi-circle-slash_js"
	],
	"./24px/mi-clipboard-check-text.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-clipboard-check-text.js",
		"node_modules_maersk-global_icons_js_24px_mi-clipboard-check-text_js"
	],
	"./24px/mi-clipboard-check.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-clipboard-check.js",
		"node_modules_maersk-global_icons_js_24px_mi-clipboard-check_js"
	],
	"./24px/mi-clipboard-list-text.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-clipboard-list-text.js",
		"node_modules_maersk-global_icons_js_24px_mi-clipboard-list-text_js"
	],
	"./24px/mi-clipboard-officer-text.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-clipboard-officer-text.js",
		"node_modules_maersk-global_icons_js_24px_mi-clipboard-officer-text_js"
	],
	"./24px/mi-clipboard-snowflake-text.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-clipboard-snowflake-text.js",
		"node_modules_maersk-global_icons_js_24px_mi-clipboard-snowflake-text_js"
	],
	"./24px/mi-clipboard-text.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-clipboard-text.js",
		"node_modules_maersk-global_icons_js_24px_mi-clipboard-text_js"
	],
	"./24px/mi-clock-alarm.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-clock-alarm.js",
		"node_modules_maersk-global_icons_js_24px_mi-clock-alarm_js"
	],
	"./24px/mi-clock-solid.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-clock-solid.js",
		"node_modules_maersk-global_icons_js_24px_mi-clock-solid_js"
	],
	"./24px/mi-clock-stopwatch.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-clock-stopwatch.js",
		"node_modules_maersk-global_icons_js_24px_mi-clock-stopwatch_js"
	],
	"./24px/mi-clock.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-clock.js",
		"node_modules_maersk-global_icons_js_24px_mi-clock_js"
	],
	"./24px/mi-cloud.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-cloud.js",
		"node_modules_maersk-global_icons_js_24px_mi-cloud_js"
	],
	"./24px/mi-coat.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-coat.js",
		"node_modules_maersk-global_icons_js_24px_mi-coat_js"
	],
	"./24px/mi-cog-play.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-cog-play.js",
		"node_modules_maersk-global_icons_js_24px_mi-cog-play_js"
	],
	"./24px/mi-cog.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-cog.js",
		"node_modules_maersk-global_icons_js_24px_mi-cog_js"
	],
	"./24px/mi-combined-arrow-down.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-combined-arrow-down.js",
		"node_modules_maersk-global_icons_js_24px_mi-combined-arrow-down_js"
	],
	"./24px/mi-combined-arrow-left.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-combined-arrow-left.js",
		"node_modules_maersk-global_icons_js_24px_mi-combined-arrow-left_js"
	],
	"./24px/mi-combined-arrow-right.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-combined-arrow-right.js",
		"node_modules_maersk-global_icons_js_24px_mi-combined-arrow-right_js"
	],
	"./24px/mi-combined-arrow-up.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-combined-arrow-up.js",
		"node_modules_maersk-global_icons_js_24px_mi-combined-arrow-up_js"
	],
	"./24px/mi-comment-dollar.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-comment-dollar.js",
		"node_modules_maersk-global_icons_js_24px_mi-comment-dollar_js"
	],
	"./24px/mi-comment-dots.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-comment-dots.js",
		"node_modules_maersk-global_icons_js_24px_mi-comment-dots_js"
	],
	"./24px/mi-comment-minus.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-comment-minus.js",
		"node_modules_maersk-global_icons_js_24px_mi-comment-minus_js"
	],
	"./24px/mi-comment-off.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-comment-off.js",
		"node_modules_maersk-global_icons_js_24px_mi-comment-off_js"
	],
	"./24px/mi-comment-plus.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-comment-plus.js",
		"node_modules_maersk-global_icons_js_24px_mi-comment-plus_js"
	],
	"./24px/mi-comment.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-comment.js",
		"node_modules_maersk-global_icons_js_24px_mi-comment_js"
	],
	"./24px/mi-comments.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-comments.js",
		"node_modules_maersk-global_icons_js_24px_mi-comments_js"
	],
	"./24px/mi-computer.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-computer.js",
		"node_modules_maersk-global_icons_js_24px_mi-computer_js"
	],
	"./24px/mi-container-down.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-container-down.js",
		"node_modules_maersk-global_icons_js_24px_mi-container-down_js"
	],
	"./24px/mi-container-flat-rack.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-container-flat-rack.js",
		"node_modules_maersk-global_icons_js_24px_mi-container-flat-rack_js"
	],
	"./24px/mi-container-handler-2.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-container-handler-2.js",
		"node_modules_maersk-global_icons_js_24px_mi-container-handler-2_js"
	],
	"./24px/mi-container-handler.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-container-handler.js",
		"node_modules_maersk-global_icons_js_24px_mi-container-handler_js"
	],
	"./24px/mi-container-high-cube.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-container-high-cube.js",
		"node_modules_maersk-global_icons_js_24px_mi-container-high-cube_js"
	],
	"./24px/mi-container-hook.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-container-hook.js",
		"node_modules_maersk-global_icons_js_24px_mi-container-hook_js"
	],
	"./24px/mi-container-in.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-container-in.js",
		"node_modules_maersk-global_icons_js_24px_mi-container-in_js"
	],
	"./24px/mi-container-left.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-container-left.js",
		"node_modules_maersk-global_icons_js_24px_mi-container-left_js"
	],
	"./24px/mi-container-link.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-container-link.js",
		"node_modules_maersk-global_icons_js_24px_mi-container-link_js"
	],
	"./24px/mi-container-open-top.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-container-open-top.js",
		"node_modules_maersk-global_icons_js_24px_mi-container-open-top_js"
	],
	"./24px/mi-container-out.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-container-out.js",
		"node_modules_maersk-global_icons_js_24px_mi-container-out_js"
	],
	"./24px/mi-container-reefer.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-container-reefer.js",
		"node_modules_maersk-global_icons_js_24px_mi-container-reefer_js"
	],
	"./24px/mi-container-right.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-container-right.js",
		"node_modules_maersk-global_icons_js_24px_mi-container-right_js"
	],
	"./24px/mi-container-stacked-alt.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-container-stacked-alt.js",
		"node_modules_maersk-global_icons_js_24px_mi-container-stacked-alt_js"
	],
	"./24px/mi-container-stacked.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-container-stacked.js",
		"node_modules_maersk-global_icons_js_24px_mi-container-stacked_js"
	],
	"./24px/mi-container-tank.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-container-tank.js",
		"node_modules_maersk-global_icons_js_24px_mi-container-tank_js"
	],
	"./24px/mi-container-tracking.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-container-tracking.js",
		"node_modules_maersk-global_icons_js_24px_mi-container-tracking_js"
	],
	"./24px/mi-container-up.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-container-up.js",
		"node_modules_maersk-global_icons_js_24px_mi-container-up_js"
	],
	"./24px/mi-container.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-container.js",
		"node_modules_maersk-global_icons_js_24px_mi-container_js"
	],
	"./24px/mi-contains.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-contains.js",
		"node_modules_maersk-global_icons_js_24px_mi-contains_js"
	],
	"./24px/mi-conveyor-belt.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-conveyor-belt.js",
		"node_modules_maersk-global_icons_js_24px_mi-conveyor-belt_js"
	],
	"./24px/mi-cookie.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-cookie.js",
		"node_modules_maersk-global_icons_js_24px_mi-cookie_js"
	],
	"./24px/mi-copy.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-copy.js",
		"node_modules_maersk-global_icons_js_24px_mi-copy_js"
	],
	"./24px/mi-cotton.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-cotton.js",
		"node_modules_maersk-global_icons_js_24px_mi-cotton_js"
	],
	"./24px/mi-cow-head.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-cow-head.js",
		"node_modules_maersk-global_icons_js_24px_mi-cow-head_js"
	],
	"./24px/mi-cow-side.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-cow-side.js",
		"node_modules_maersk-global_icons_js_24px_mi-cow-side_js"
	],
	"./24px/mi-crane.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-crane.js",
		"node_modules_maersk-global_icons_js_24px_mi-crane_js"
	],
	"./24px/mi-credit-card-back.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-credit-card-back.js",
		"node_modules_maersk-global_icons_js_24px_mi-credit-card-back_js"
	],
	"./24px/mi-credit-card-front.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-credit-card-front.js",
		"node_modules_maersk-global_icons_js_24px_mi-credit-card-front_js"
	],
	"./24px/mi-crosshair.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-crosshair.js",
		"node_modules_maersk-global_icons_js_24px_mi-crosshair_js"
	],
	"./24px/mi-database.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-database.js",
		"node_modules_maersk-global_icons_js_24px_mi-database_js"
	],
	"./24px/mi-dollar-circle-solid.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-dollar-circle-solid.js",
		"node_modules_maersk-global_icons_js_24px_mi-dollar-circle-solid_js"
	],
	"./24px/mi-dollar-circle.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-dollar-circle.js",
		"node_modules_maersk-global_icons_js_24px_mi-dollar-circle_js"
	],
	"./24px/mi-door-arrow-right.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-door-arrow-right.js",
		"node_modules_maersk-global_icons_js_24px_mi-door-arrow-right_js"
	],
	"./24px/mi-dot-grid-2x3.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-dot-grid-2x3.js",
		"node_modules_maersk-global_icons_js_24px_mi-dot-grid-2x3_js"
	],
	"./24px/mi-dot-grid-3x2.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-dot-grid-3x2.js",
		"node_modules_maersk-global_icons_js_24px_mi-dot-grid-3x2_js"
	],
	"./24px/mi-dot-grid.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-dot-grid.js",
		"node_modules_maersk-global_icons_js_24px_mi-dot-grid_js"
	],
	"./24px/mi-double-chevron-down.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-double-chevron-down.js",
		"node_modules_maersk-global_icons_js_24px_mi-double-chevron-down_js"
	],
	"./24px/mi-double-chevron-left.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-double-chevron-left.js",
		"node_modules_maersk-global_icons_js_24px_mi-double-chevron-left_js"
	],
	"./24px/mi-double-chevron-right.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-double-chevron-right.js",
		"node_modules_maersk-global_icons_js_24px_mi-double-chevron-right_js"
	],
	"./24px/mi-double-chevron-up.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-double-chevron-up.js",
		"node_modules_maersk-global_icons_js_24px_mi-double-chevron-up_js"
	],
	"./24px/mi-dress.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-dress.js",
		"node_modules_maersk-global_icons_js_24px_mi-dress_js"
	],
	"./24px/mi-droplet.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-droplet.js",
		"node_modules_maersk-global_icons_js_24px_mi-droplet_js"
	],
	"./24px/mi-ellipsis-horizontal.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-ellipsis-horizontal.js",
		"node_modules_maersk-global_icons_js_24px_mi-ellipsis-horizontal_js"
	],
	"./24px/mi-ellipsis-vertical.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-ellipsis-vertical.js",
		"node_modules_maersk-global_icons_js_24px_mi-ellipsis-vertical_js"
	],
	"./24px/mi-emergency-light.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-emergency-light.js",
		"node_modules_maersk-global_icons_js_24px_mi-emergency-light_js"
	],
	"./24px/mi-engine.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-engine.js",
		"node_modules_maersk-global_icons_js_24px_mi-engine_js"
	],
	"./24px/mi-envelope-times-circle.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-envelope-times-circle.js",
		"node_modules_maersk-global_icons_js_24px_mi-envelope-times-circle_js"
	],
	"./24px/mi-envelope.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-envelope.js",
		"node_modules_maersk-global_icons_js_24px_mi-envelope_js"
	],
	"./24px/mi-equal.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-equal.js",
		"node_modules_maersk-global_icons_js_24px_mi-equal_js"
	],
	"./24px/mi-euro-circle.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-euro-circle.js",
		"node_modules_maersk-global_icons_js_24px_mi-euro-circle_js"
	],
	"./24px/mi-exclamation-circle-solid.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-exclamation-circle-solid.js",
		"node_modules_maersk-global_icons_js_24px_mi-exclamation-circle-solid_js"
	],
	"./24px/mi-exclamation-circle.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-exclamation-circle.js",
		"node_modules_maersk-global_icons_js_24px_mi-exclamation-circle_js"
	],
	"./24px/mi-exclamation-octagon-solid.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-exclamation-octagon-solid.js",
		"node_modules_maersk-global_icons_js_24px_mi-exclamation-octagon-solid_js"
	],
	"./24px/mi-exclamation-octagon.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-exclamation-octagon.js",
		"node_modules_maersk-global_icons_js_24px_mi-exclamation-octagon_js"
	],
	"./24px/mi-exclamation-triangle-solid.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-exclamation-triangle-solid.js",
		"node_modules_maersk-global_icons_js_24px_mi-exclamation-triangle-solid_js"
	],
	"./24px/mi-exclamation-triangle.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-exclamation-triangle.js",
		"node_modules_maersk-global_icons_js_24px_mi-exclamation-triangle_js"
	],
	"./24px/mi-expand.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-expand.js",
		"node_modules_maersk-global_icons_js_24px_mi-expand_js"
	],
	"./24px/mi-eye-slash-focus.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-eye-slash-focus.js",
		"node_modules_maersk-global_icons_js_24px_mi-eye-slash-focus_js"
	],
	"./24px/mi-eye-slash.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-eye-slash.js",
		"node_modules_maersk-global_icons_js_24px_mi-eye-slash_js"
	],
	"./24px/mi-eye.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-eye.js",
		"node_modules_maersk-global_icons_js_24px_mi-eye_js"
	],
	"./24px/mi-face-happy-solid.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-face-happy-solid.js",
		"node_modules_maersk-global_icons_js_24px_mi-face-happy-solid_js"
	],
	"./24px/mi-face-happy.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-face-happy.js",
		"node_modules_maersk-global_icons_js_24px_mi-face-happy_js"
	],
	"./24px/mi-face-indifferent-solid.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-face-indifferent-solid.js",
		"node_modules_maersk-global_icons_js_24px_mi-face-indifferent-solid_js"
	],
	"./24px/mi-face-indifferent.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-face-indifferent.js",
		"node_modules_maersk-global_icons_js_24px_mi-face-indifferent_js"
	],
	"./24px/mi-face-sad-solid.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-face-sad-solid.js",
		"node_modules_maersk-global_icons_js_24px_mi-face-sad-solid_js"
	],
	"./24px/mi-face-sad.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-face-sad.js",
		"node_modules_maersk-global_icons_js_24px_mi-face-sad_js"
	],
	"./24px/mi-face-very-happy-solid.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-face-very-happy-solid.js",
		"node_modules_maersk-global_icons_js_24px_mi-face-very-happy-solid_js"
	],
	"./24px/mi-face-very-happy.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-face-very-happy.js",
		"node_modules_maersk-global_icons_js_24px_mi-face-very-happy_js"
	],
	"./24px/mi-face-very-sad-solid.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-face-very-sad-solid.js",
		"node_modules_maersk-global_icons_js_24px_mi-face-very-sad-solid_js"
	],
	"./24px/mi-face-very-sad.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-face-very-sad.js",
		"node_modules_maersk-global_icons_js_24px_mi-face-very-sad_js"
	],
	"./24px/mi-factory.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-factory.js",
		"node_modules_maersk-global_icons_js_24px_mi-factory_js"
	],
	"./24px/mi-file-arrows-square.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-file-arrows-square.js",
		"node_modules_maersk-global_icons_js_24px_mi-file-arrows-square_js"
	],
	"./24px/mi-file-check-stamp.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-file-check-stamp.js",
		"node_modules_maersk-global_icons_js_24px_mi-file-check-stamp_js"
	],
	"./24px/mi-file-check.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-file-check.js",
		"node_modules_maersk-global_icons_js_24px_mi-file-check_js"
	],
	"./24px/mi-file-copy.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-file-copy.js",
		"node_modules_maersk-global_icons_js_24px_mi-file-copy_js"
	],
	"./24px/mi-file-csv.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-file-csv.js",
		"node_modules_maersk-global_icons_js_24px_mi-file-csv_js"
	],
	"./24px/mi-file-excel.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-file-excel.js",
		"node_modules_maersk-global_icons_js_24px_mi-file-excel_js"
	],
	"./24px/mi-file-eye.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-file-eye.js",
		"node_modules_maersk-global_icons_js_24px_mi-file-eye_js"
	],
	"./24px/mi-file-magnifying-glass.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-file-magnifying-glass.js",
		"node_modules_maersk-global_icons_js_24px_mi-file-magnifying-glass_js"
	],
	"./24px/mi-file-other.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-file-other.js",
		"node_modules_maersk-global_icons_js_24px_mi-file-other_js"
	],
	"./24px/mi-file-pdf.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-file-pdf.js",
		"node_modules_maersk-global_icons_js_24px_mi-file-pdf_js"
	],
	"./24px/mi-file-ribbon.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-file-ribbon.js",
		"node_modules_maersk-global_icons_js_24px_mi-file-ribbon_js"
	],
	"./24px/mi-file.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-file.js",
		"node_modules_maersk-global_icons_js_24px_mi-file_js"
	],
	"./24px/mi-fish.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-fish.js",
		"node_modules_maersk-global_icons_js_24px_mi-fish_js"
	],
	"./24px/mi-flag.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-flag.js",
		"node_modules_maersk-global_icons_js_24px_mi-flag_js"
	],
	"./24px/mi-flame.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-flame.js",
		"node_modules_maersk-global_icons_js_24px_mi-flame_js"
	],
	"./24px/mi-floppy-disk.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-floppy-disk.js",
		"node_modules_maersk-global_icons_js_24px_mi-floppy-disk_js"
	],
	"./24px/mi-flow-diagram.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-flow-diagram.js",
		"node_modules_maersk-global_icons_js_24px_mi-flow-diagram_js"
	],
	"./24px/mi-flow.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-flow.js",
		"node_modules_maersk-global_icons_js_24px_mi-flow_js"
	],
	"./24px/mi-folder-arrow-down.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-folder-arrow-down.js",
		"node_modules_maersk-global_icons_js_24px_mi-folder-arrow-down_js"
	],
	"./24px/mi-folder-arrow-up.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-folder-arrow-up.js",
		"node_modules_maersk-global_icons_js_24px_mi-folder-arrow-up_js"
	],
	"./24px/mi-folder-minus.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-folder-minus.js",
		"node_modules_maersk-global_icons_js_24px_mi-folder-minus_js"
	],
	"./24px/mi-folder-open.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-folder-open.js",
		"node_modules_maersk-global_icons_js_24px_mi-folder-open_js"
	],
	"./24px/mi-folder-plus.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-folder-plus.js",
		"node_modules_maersk-global_icons_js_24px_mi-folder-plus_js"
	],
	"./24px/mi-folder-solid.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-folder-solid.js",
		"node_modules_maersk-global_icons_js_24px_mi-folder-solid_js"
	],
	"./24px/mi-folder.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-folder.js",
		"node_modules_maersk-global_icons_js_24px_mi-folder_js"
	],
	"./24px/mi-fuel-pump.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-fuel-pump.js",
		"node_modules_maersk-global_icons_js_24px_mi-fuel-pump_js"
	],
	"./24px/mi-funnel-solid.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-funnel-solid.js",
		"node_modules_maersk-global_icons_js_24px_mi-funnel-solid_js"
	],
	"./24px/mi-funnel.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-funnel.js",
		"node_modules_maersk-global_icons_js_24px_mi-funnel_js"
	],
	"./24px/mi-game-controller.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-game-controller.js",
		"node_modules_maersk-global_icons_js_24px_mi-game-controller_js"
	],
	"./24px/mi-gift.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-gift.js",
		"node_modules_maersk-global_icons_js_24px_mi-gift_js"
	],
	"./24px/mi-globe.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-globe.js",
		"node_modules_maersk-global_icons_js_24px_mi-globe_js"
	],
	"./24px/mi-greater-than-equal.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-greater-than-equal.js",
		"node_modules_maersk-global_icons_js_24px_mi-greater-than-equal_js"
	],
	"./24px/mi-greater-than.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-greater-than.js",
		"node_modules_maersk-global_icons_js_24px_mi-greater-than_js"
	],
	"./24px/mi-grid.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-grid.js",
		"node_modules_maersk-global_icons_js_24px_mi-grid_js"
	],
	"./24px/mi-hair-dryer.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-hair-dryer.js",
		"node_modules_maersk-global_icons_js_24px_mi-hair-dryer_js"
	],
	"./24px/mi-handshake.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-handshake.js",
		"node_modules_maersk-global_icons_js_24px_mi-handshake_js"
	],
	"./24px/mi-headset.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-headset.js",
		"node_modules_maersk-global_icons_js_24px_mi-headset_js"
	],
	"./24px/mi-heart-solid.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-heart-solid.js",
		"node_modules_maersk-global_icons_js_24px_mi-heart-solid_js"
	],
	"./24px/mi-heart.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-heart.js",
		"node_modules_maersk-global_icons_js_24px_mi-heart_js"
	],
	"./24px/mi-high-heel.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-high-heel.js",
		"node_modules_maersk-global_icons_js_24px_mi-high-heel_js"
	],
	"./24px/mi-hook-arrow-left.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-hook-arrow-left.js",
		"node_modules_maersk-global_icons_js_24px_mi-hook-arrow-left_js"
	],
	"./24px/mi-hook-arrow-right.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-hook-arrow-right.js",
		"node_modules_maersk-global_icons_js_24px_mi-hook-arrow-right_js"
	],
	"./24px/mi-house-solid.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-house-solid.js",
		"node_modules_maersk-global_icons_js_24px_mi-house-solid_js"
	],
	"./24px/mi-house.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-house.js",
		"node_modules_maersk-global_icons_js_24px_mi-house_js"
	],
	"./24px/mi-image-polaroid.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-image-polaroid.js",
		"node_modules_maersk-global_icons_js_24px_mi-image-polaroid_js"
	],
	"./24px/mi-image.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-image.js",
		"node_modules_maersk-global_icons_js_24px_mi-image_js"
	],
	"./24px/mi-info-circle-solid.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-info-circle-solid.js",
		"node_modules_maersk-global_icons_js_24px_mi-info-circle-solid_js"
	],
	"./24px/mi-info-circle.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-info-circle.js",
		"node_modules_maersk-global_icons_js_24px_mi-info-circle_js"
	],
	"./24px/mi-jerrycan.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-jerrycan.js",
		"node_modules_maersk-global_icons_js_24px_mi-jerrycan_js"
	],
	"./24px/mi-language.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-language.js",
		"node_modules_maersk-global_icons_js_24px_mi-language_js"
	],
	"./24px/mi-laptop-shopping-cart.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-laptop-shopping-cart.js",
		"node_modules_maersk-global_icons_js_24px_mi-laptop-shopping-cart_js"
	],
	"./24px/mi-laptop.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-laptop.js",
		"node_modules_maersk-global_icons_js_24px_mi-laptop_js"
	],
	"./24px/mi-layout-2x2.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-layout-2x2.js",
		"node_modules_maersk-global_icons_js_24px_mi-layout-2x2_js"
	],
	"./24px/mi-leaf.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-leaf.js",
		"node_modules_maersk-global_icons_js_24px_mi-leaf_js"
	],
	"./24px/mi-lemon-slice.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-lemon-slice.js",
		"node_modules_maersk-global_icons_js_24px_mi-lemon-slice_js"
	],
	"./24px/mi-lemon.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-lemon.js",
		"node_modules_maersk-global_icons_js_24px_mi-lemon_js"
	],
	"./24px/mi-less-than-equal.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-less-than-equal.js",
		"node_modules_maersk-global_icons_js_24px_mi-less-than-equal_js"
	],
	"./24px/mi-less-than.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-less-than.js",
		"node_modules_maersk-global_icons_js_24px_mi-less-than_js"
	],
	"./24px/mi-lifebuoy.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-lifebuoy.js",
		"node_modules_maersk-global_icons_js_24px_mi-lifebuoy_js"
	],
	"./24px/mi-light-bulb.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-light-bulb.js",
		"node_modules_maersk-global_icons_js_24px_mi-light-bulb_js"
	],
	"./24px/mi-lightning.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-lightning.js",
		"node_modules_maersk-global_icons_js_24px_mi-lightning_js"
	],
	"./24px/mi-link.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-link.js",
		"node_modules_maersk-global_icons_js_24px_mi-link_js"
	],
	"./24px/mi-list-bullets.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-list-bullets.js",
		"node_modules_maersk-global_icons_js_24px_mi-list-bullets_js"
	],
	"./24px/mi-list-numbers.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-list-numbers.js",
		"node_modules_maersk-global_icons_js_24px_mi-list-numbers_js"
	],
	"./24px/mi-lock-solid.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-lock-solid.js",
		"node_modules_maersk-global_icons_js_24px_mi-lock-solid_js"
	],
	"./24px/mi-lock-unlocked-solid.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-lock-unlocked-solid.js",
		"node_modules_maersk-global_icons_js_24px_mi-lock-unlocked-solid_js"
	],
	"./24px/mi-lock-unlocked.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-lock-unlocked.js",
		"node_modules_maersk-global_icons_js_24px_mi-lock-unlocked_js"
	],
	"./24px/mi-lock.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-lock.js",
		"node_modules_maersk-global_icons_js_24px_mi-lock_js"
	],
	"./24px/mi-magnifying-glass.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-magnifying-glass.js",
		"node_modules_maersk-global_icons_js_24px_mi-magnifying-glass_js"
	],
	"./24px/mi-man.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-man.js",
		"node_modules_maersk-global_icons_js_24px_mi-man_js"
	],
	"./24px/mi-map.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-map.js",
		"node_modules_maersk-global_icons_js_24px_mi-map_js"
	],
	"./24px/mi-medal.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-medal.js",
		"node_modules_maersk-global_icons_js_24px_mi-medal_js"
	],
	"./24px/mi-medicine-bottle.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-medicine-bottle.js",
		"node_modules_maersk-global_icons_js_24px_mi-medicine-bottle_js"
	],
	"./24px/mi-megaphone.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-megaphone.js",
		"node_modules_maersk-global_icons_js_24px_mi-megaphone_js"
	],
	"./24px/mi-microphone-off.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-microphone-off.js",
		"node_modules_maersk-global_icons_js_24px_mi-microphone-off_js"
	],
	"./24px/mi-microphone.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-microphone.js",
		"node_modules_maersk-global_icons_js_24px_mi-microphone_js"
	],
	"./24px/mi-minus-circle-solid.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-minus-circle-solid.js",
		"node_modules_maersk-global_icons_js_24px_mi-minus-circle-solid_js"
	],
	"./24px/mi-minus-circle.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-minus-circle.js",
		"node_modules_maersk-global_icons_js_24px_mi-minus-circle_js"
	],
	"./24px/mi-minus.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-minus.js",
		"node_modules_maersk-global_icons_js_24px_mi-minus_js"
	],
	"./24px/mi-mobile-phone.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-mobile-phone.js",
		"node_modules_maersk-global_icons_js_24px_mi-mobile-phone_js"
	],
	"./24px/mi-module-1.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-module-1.js",
		"node_modules_maersk-global_icons_js_24px_mi-module-1_js"
	],
	"./24px/mi-module-2.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-module-2.js",
		"node_modules_maersk-global_icons_js_24px_mi-module-2_js"
	],
	"./24px/mi-monitor.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-monitor.js",
		"node_modules_maersk-global_icons_js_24px_mi-monitor_js"
	],
	"./24px/mi-moon-solid.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-moon-solid.js",
		"node_modules_maersk-global_icons_js_24px_mi-moon-solid_js"
	],
	"./24px/mi-moon.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-moon.js",
		"node_modules_maersk-global_icons_js_24px_mi-moon_js"
	],
	"./24px/mi-mouse.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-mouse.js",
		"node_modules_maersk-global_icons_js_24px_mi-mouse_js"
	],
	"./24px/mi-navigation-arrow-up-right.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-navigation-arrow-up-right.js",
		"node_modules_maersk-global_icons_js_24px_mi-navigation-arrow-up-right_js"
	],
	"./24px/mi-navigation-arrow-up.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-navigation-arrow-up.js",
		"node_modules_maersk-global_icons_js_24px_mi-navigation-arrow-up_js"
	],
	"./24px/mi-newspaper.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-newspaper.js",
		"node_modules_maersk-global_icons_js_24px_mi-newspaper_js"
	],
	"./24px/mi-next-circle.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-next-circle.js",
		"node_modules_maersk-global_icons_js_24px_mi-next-circle_js"
	],
	"./24px/mi-next.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-next.js",
		"node_modules_maersk-global_icons_js_24px_mi-next_js"
	],
	"./24px/mi-not-equal.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-not-equal.js",
		"node_modules_maersk-global_icons_js_24px_mi-not-equal_js"
	],
	"./24px/mi-office-1.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-office-1.js",
		"node_modules_maersk-global_icons_js_24px_mi-office-1_js"
	],
	"./24px/mi-office-2.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-office-2.js",
		"node_modules_maersk-global_icons_js_24px_mi-office-2_js"
	],
	"./24px/mi-oil-well.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-oil-well.js",
		"node_modules_maersk-global_icons_js_24px_mi-oil-well_js"
	],
	"./24px/mi-org-chart.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-org-chart.js",
		"node_modules_maersk-global_icons_js_24px_mi-org-chart_js"
	],
	"./24px/mi-oven.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-oven.js",
		"node_modules_maersk-global_icons_js_24px_mi-oven_js"
	],
	"./24px/mi-package-door.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-package-door.js",
		"node_modules_maersk-global_icons_js_24px_mi-package-door_js"
	],
	"./24px/mi-package-open.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-package-open.js",
		"node_modules_maersk-global_icons_js_24px_mi-package-open_js"
	],
	"./24px/mi-package.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-package.js",
		"node_modules_maersk-global_icons_js_24px_mi-package_js"
	],
	"./24px/mi-pallet-empty.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-pallet-empty.js",
		"node_modules_maersk-global_icons_js_24px_mi-pallet-empty_js"
	],
	"./24px/mi-pallet.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-pallet.js",
		"node_modules_maersk-global_icons_js_24px_mi-pallet_js"
	],
	"./24px/mi-paper-plane.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-paper-plane.js",
		"node_modules_maersk-global_icons_js_24px_mi-paper-plane_js"
	],
	"./24px/mi-paperclip.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-paperclip.js",
		"node_modules_maersk-global_icons_js_24px_mi-paperclip_js"
	],
	"./24px/mi-pause-circle.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-pause-circle.js",
		"node_modules_maersk-global_icons_js_24px_mi-pause-circle_js"
	],
	"./24px/mi-pause.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-pause.js",
		"node_modules_maersk-global_icons_js_24px_mi-pause_js"
	],
	"./24px/mi-pencil.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-pencil.js",
		"node_modules_maersk-global_icons_js_24px_mi-pencil_js"
	],
	"./24px/mi-people.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-people.js",
		"node_modules_maersk-global_icons_js_24px_mi-people_js"
	],
	"./24px/mi-person-side-hand.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-person-side-hand.js",
		"node_modules_maersk-global_icons_js_24px_mi-person-side-hand_js"
	],
	"./24px/mi-person.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-person.js",
		"node_modules_maersk-global_icons_js_24px_mi-person_js"
	],
	"./24px/mi-phone-call.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-phone-call.js",
		"node_modules_maersk-global_icons_js_24px_mi-phone-call_js"
	],
	"./24px/mi-phone.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-phone.js",
		"node_modules_maersk-global_icons_js_24px_mi-phone_js"
	],
	"./24px/mi-pig-head.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-pig-head.js",
		"node_modules_maersk-global_icons_js_24px_mi-pig-head_js"
	],
	"./24px/mi-pig-side.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-pig-side.js",
		"node_modules_maersk-global_icons_js_24px_mi-pig-side_js"
	],
	"./24px/mi-pill.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-pill.js",
		"node_modules_maersk-global_icons_js_24px_mi-pill_js"
	],
	"./24px/mi-pin-slash.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-pin-slash.js",
		"node_modules_maersk-global_icons_js_24px_mi-pin-slash_js"
	],
	"./24px/mi-pin-solid.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-pin-solid.js",
		"node_modules_maersk-global_icons_js_24px_mi-pin-solid_js"
	],
	"./24px/mi-pin.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-pin.js",
		"node_modules_maersk-global_icons_js_24px_mi-pin_js"
	],
	"./24px/mi-play-circle.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-play-circle.js",
		"node_modules_maersk-global_icons_js_24px_mi-play-circle_js"
	],
	"./24px/mi-play.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-play.js",
		"node_modules_maersk-global_icons_js_24px_mi-play_js"
	],
	"./24px/mi-plug.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-plug.js",
		"node_modules_maersk-global_icons_js_24px_mi-plug_js"
	],
	"./24px/mi-plus-circle-solid.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-plus-circle-solid.js",
		"node_modules_maersk-global_icons_js_24px_mi-plus-circle-solid_js"
	],
	"./24px/mi-plus-circle.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-plus-circle.js",
		"node_modules_maersk-global_icons_js_24px_mi-plus-circle_js"
	],
	"./24px/mi-plus.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-plus.js",
		"node_modules_maersk-global_icons_js_24px_mi-plus_js"
	],
	"./24px/mi-power.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-power.js",
		"node_modules_maersk-global_icons_js_24px_mi-power_js"
	],
	"./24px/mi-previous-circle.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-previous-circle.js",
		"node_modules_maersk-global_icons_js_24px_mi-previous-circle_js"
	],
	"./24px/mi-previous.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-previous.js",
		"node_modules_maersk-global_icons_js_24px_mi-previous_js"
	],
	"./24px/mi-printer.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-printer.js",
		"node_modules_maersk-global_icons_js_24px_mi-printer_js"
	],
	"./24px/mi-propellor.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-propellor.js",
		"node_modules_maersk-global_icons_js_24px_mi-propellor_js"
	],
	"./24px/mi-push-pin-slash.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-push-pin-slash.js",
		"node_modules_maersk-global_icons_js_24px_mi-push-pin-slash_js"
	],
	"./24px/mi-push-pin.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-push-pin.js",
		"node_modules_maersk-global_icons_js_24px_mi-push-pin_js"
	],
	"./24px/mi-puzzle-piece.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-puzzle-piece.js",
		"node_modules_maersk-global_icons_js_24px_mi-puzzle-piece_js"
	],
	"./24px/mi-qr-code-scan.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-qr-code-scan.js",
		"node_modules_maersk-global_icons_js_24px_mi-qr-code-scan_js"
	],
	"./24px/mi-qr-code.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-qr-code.js",
		"node_modules_maersk-global_icons_js_24px_mi-qr-code_js"
	],
	"./24px/mi-question-circle-solid.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-question-circle-solid.js",
		"node_modules_maersk-global_icons_js_24px_mi-question-circle-solid_js"
	],
	"./24px/mi-question-circle.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-question-circle.js",
		"node_modules_maersk-global_icons_js_24px_mi-question-circle_js"
	],
	"./24px/mi-quote.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-quote.js",
		"node_modules_maersk-global_icons_js_24px_mi-quote_js"
	],
	"./24px/mi-rack.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-rack.js",
		"node_modules_maersk-global_icons_js_24px_mi-rack_js"
	],
	"./24px/mi-radar.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-radar.js",
		"node_modules_maersk-global_icons_js_24px_mi-radar_js"
	],
	"./24px/mi-radio-tower.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-radio-tower.js",
		"node_modules_maersk-global_icons_js_24px_mi-radio-tower_js"
	],
	"./24px/mi-radio.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-radio.js",
		"node_modules_maersk-global_icons_js_24px_mi-radio_js"
	],
	"./24px/mi-receipt.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-receipt.js",
		"node_modules_maersk-global_icons_js_24px_mi-receipt_js"
	],
	"./24px/mi-rectangle.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-rectangle.js",
		"node_modules_maersk-global_icons_js_24px_mi-rectangle_js"
	],
	"./24px/mi-remote-control-hand.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-remote-control-hand.js",
		"node_modules_maersk-global_icons_js_24px_mi-remote-control-hand_js"
	],
	"./24px/mi-remote-control.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-remote-control.js",
		"node_modules_maersk-global_icons_js_24px_mi-remote-control_js"
	],
	"./24px/mi-rotate.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-rotate.js",
		"node_modules_maersk-global_icons_js_24px_mi-rotate_js"
	],
	"./24px/mi-route-network.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-route-network.js",
		"node_modules_maersk-global_icons_js_24px_mi-route-network_js"
	],
	"./24px/mi-route.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-route.js",
		"node_modules_maersk-global_icons_js_24px_mi-route_js"
	],
	"./24px/mi-rubber-tyred-gantry-crane.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-rubber-tyred-gantry-crane.js",
		"node_modules_maersk-global_icons_js_24px_mi-rubber-tyred-gantry-crane_js"
	],
	"./24px/mi-ruler.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-ruler.js",
		"node_modules_maersk-global_icons_js_24px_mi-ruler_js"
	],
	"./24px/mi-safety-gear.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-safety-gear.js",
		"node_modules_maersk-global_icons_js_24px_mi-safety-gear_js"
	],
	"./24px/mi-safety-helmet.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-safety-helmet.js",
		"node_modules_maersk-global_icons_js_24px_mi-safety-helmet_js"
	],
	"./24px/mi-sandbox.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-sandbox.js",
		"node_modules_maersk-global_icons_js_24px_mi-sandbox_js"
	],
	"./24px/mi-scale-balance.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-scale-balance.js",
		"node_modules_maersk-global_icons_js_24px_mi-scale-balance_js"
	],
	"./24px/mi-scale.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-scale.js",
		"node_modules_maersk-global_icons_js_24px_mi-scale_js"
	],
	"./24px/mi-scissors.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-scissors.js",
		"node_modules_maersk-global_icons_js_24px_mi-scissors_js"
	],
	"./24px/mi-shapes.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-shapes.js",
		"node_modules_maersk-global_icons_js_24px_mi-shapes_js"
	],
	"./24px/mi-share.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-share.js",
		"node_modules_maersk-global_icons_js_24px_mi-share_js"
	],
	"./24px/mi-shield-check.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-shield-check.js",
		"node_modules_maersk-global_icons_js_24px_mi-shield-check_js"
	],
	"./24px/mi-shield-key.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-shield-key.js",
		"node_modules_maersk-global_icons_js_24px_mi-shield-key_js"
	],
	"./24px/mi-shield-lock.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-shield-lock.js",
		"node_modules_maersk-global_icons_js_24px_mi-shield-lock_js"
	],
	"./24px/mi-shield.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-shield.js",
		"node_modules_maersk-global_icons_js_24px_mi-shield_js"
	],
	"./24px/mi-shoe.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-shoe.js",
		"node_modules_maersk-global_icons_js_24px_mi-shoe_js"
	],
	"./24px/mi-shopping-cart-return.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-shopping-cart-return.js",
		"node_modules_maersk-global_icons_js_24px_mi-shopping-cart-return_js"
	],
	"./24px/mi-shopping-cart.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-shopping-cart.js",
		"node_modules_maersk-global_icons_js_24px_mi-shopping-cart_js"
	],
	"./24px/mi-shrimp.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-shrimp.js",
		"node_modules_maersk-global_icons_js_24px_mi-shrimp_js"
	],
	"./24px/mi-shrink.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-shrink.js",
		"node_modules_maersk-global_icons_js_24px_mi-shrink_js"
	],
	"./24px/mi-shuttle-carrier.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-shuttle-carrier.js",
		"node_modules_maersk-global_icons_js_24px_mi-shuttle-carrier_js"
	],
	"./24px/mi-sidebar-left-arrow-left.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-sidebar-left-arrow-left.js",
		"node_modules_maersk-global_icons_js_24px_mi-sidebar-left-arrow-left_js"
	],
	"./24px/mi-sidebar-left-arrow-right.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-sidebar-left-arrow-right.js",
		"node_modules_maersk-global_icons_js_24px_mi-sidebar-left-arrow-right_js"
	],
	"./24px/mi-sidebar-right-arrow-right.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-sidebar-right-arrow-right.js",
		"node_modules_maersk-global_icons_js_24px_mi-sidebar-right-arrow-right_js"
	],
	"./24px/mi-signpost.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-signpost.js",
		"node_modules_maersk-global_icons_js_24px_mi-signpost_js"
	],
	"./24px/mi-sliders-horizontal.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-sliders-horizontal.js",
		"node_modules_maersk-global_icons_js_24px_mi-sliders-horizontal_js"
	],
	"./24px/mi-sliders-vertical.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-sliders-vertical.js",
		"node_modules_maersk-global_icons_js_24px_mi-sliders-vertical_js"
	],
	"./24px/mi-snowflake.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-snowflake.js",
		"node_modules_maersk-global_icons_js_24px_mi-snowflake_js"
	],
	"./24px/mi-socks.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-socks.js",
		"node_modules_maersk-global_icons_js_24px_mi-socks_js"
	],
	"./24px/mi-sparkle.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-sparkle.js",
		"node_modules_maersk-global_icons_js_24px_mi-sparkle_js"
	],
	"./24px/mi-speaker-high-volume.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-speaker-high-volume.js",
		"node_modules_maersk-global_icons_js_24px_mi-speaker-high-volume_js"
	],
	"./24px/mi-speaker-low-volume.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-speaker-low-volume.js",
		"node_modules_maersk-global_icons_js_24px_mi-speaker-low-volume_js"
	],
	"./24px/mi-speaker-mute.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-speaker-mute.js",
		"node_modules_maersk-global_icons_js_24px_mi-speaker-mute_js"
	],
	"./24px/mi-speedometer.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-speedometer.js",
		"node_modules_maersk-global_icons_js_24px_mi-speedometer_js"
	],
	"./24px/mi-square-arrow-up-right.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-square-arrow-up-right.js",
		"node_modules_maersk-global_icons_js_24px_mi-square-arrow-up-right_js"
	],
	"./24px/mi-square-arrow-up.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-square-arrow-up.js",
		"node_modules_maersk-global_icons_js_24px_mi-square-arrow-up_js"
	],
	"./24px/mi-square.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-square.js",
		"node_modules_maersk-global_icons_js_24px_mi-square_js"
	],
	"./24px/mi-stack.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-stack.js",
		"node_modules_maersk-global_icons_js_24px_mi-stack_js"
	],
	"./24px/mi-stamp.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-stamp.js",
		"node_modules_maersk-global_icons_js_24px_mi-stamp_js"
	],
	"./24px/mi-star-solid.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-star-solid.js",
		"node_modules_maersk-global_icons_js_24px_mi-star-solid_js"
	],
	"./24px/mi-star.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-star.js",
		"node_modules_maersk-global_icons_js_24px_mi-star_js"
	],
	"./24px/mi-steering-wheel.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-steering-wheel.js",
		"node_modules_maersk-global_icons_js_24px_mi-steering-wheel_js"
	],
	"./24px/mi-stop-circle.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-stop-circle.js",
		"node_modules_maersk-global_icons_js_24px_mi-stop-circle_js"
	],
	"./24px/mi-stop.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-stop.js",
		"node_modules_maersk-global_icons_js_24px_mi-stop_js"
	],
	"./24px/mi-store.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-store.js",
		"node_modules_maersk-global_icons_js_24px_mi-store_js"
	],
	"./24px/mi-sun-solid.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-sun-solid.js",
		"node_modules_maersk-global_icons_js_24px_mi-sun-solid_js"
	],
	"./24px/mi-sun.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-sun.js",
		"node_modules_maersk-global_icons_js_24px_mi-sun_js"
	],
	"./24px/mi-sustainability.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-sustainability.js",
		"node_modules_maersk-global_icons_js_24px_mi-sustainability_js"
	],
	"./24px/mi-t-shirt.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-t-shirt.js",
		"node_modules_maersk-global_icons_js_24px_mi-t-shirt_js"
	],
	"./24px/mi-table.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-table.js",
		"node_modules_maersk-global_icons_js_24px_mi-table_js"
	],
	"./24px/mi-tablet.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-tablet.js",
		"node_modules_maersk-global_icons_js_24px_mi-tablet_js"
	],
	"./24px/mi-tachometer.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-tachometer.js",
		"node_modules_maersk-global_icons_js_24px_mi-tachometer_js"
	],
	"./24px/mi-tag.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-tag.js",
		"node_modules_maersk-global_icons_js_24px_mi-tag_js"
	],
	"./24px/mi-television.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-television.js",
		"node_modules_maersk-global_icons_js_24px_mi-television_js"
	],
	"./24px/mi-text.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-text.js",
		"node_modules_maersk-global_icons_js_24px_mi-text_js"
	],
	"./24px/mi-thermometer-minus.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-thermometer-minus.js",
		"node_modules_maersk-global_icons_js_24px_mi-thermometer-minus_js"
	],
	"./24px/mi-thermometer-plus.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-thermometer-plus.js",
		"node_modules_maersk-global_icons_js_24px_mi-thermometer-plus_js"
	],
	"./24px/mi-thermometer-snow.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-thermometer-snow.js",
		"node_modules_maersk-global_icons_js_24px_mi-thermometer-snow_js"
	],
	"./24px/mi-thermometer-sun.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-thermometer-sun.js",
		"node_modules_maersk-global_icons_js_24px_mi-thermometer-sun_js"
	],
	"./24px/mi-thermometer.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-thermometer.js",
		"node_modules_maersk-global_icons_js_24px_mi-thermometer_js"
	],
	"./24px/mi-thumbs-down-solid.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-thumbs-down-solid.js",
		"node_modules_maersk-global_icons_js_24px_mi-thumbs-down-solid_js"
	],
	"./24px/mi-thumbs-down.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-thumbs-down.js",
		"node_modules_maersk-global_icons_js_24px_mi-thumbs-down_js"
	],
	"./24px/mi-thumbs-up-solid.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-thumbs-up-solid.js",
		"node_modules_maersk-global_icons_js_24px_mi-thumbs-up-solid_js"
	],
	"./24px/mi-thumbs-up.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-thumbs-up.js",
		"node_modules_maersk-global_icons_js_24px_mi-thumbs-up_js"
	],
	"./24px/mi-times-circle-solid.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-times-circle-solid.js",
		"node_modules_maersk-global_icons_js_24px_mi-times-circle-solid_js"
	],
	"./24px/mi-times-circle.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-times-circle.js",
		"node_modules_maersk-global_icons_js_24px_mi-times-circle_js"
	],
	"./24px/mi-times.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-times.js",
		"node_modules_maersk-global_icons_js_24px_mi-times_js"
	],
	"./24px/mi-tire.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-tire.js",
		"node_modules_maersk-global_icons_js_24px_mi-tire_js"
	],
	"./24px/mi-train-front.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-train-front.js",
		"node_modules_maersk-global_icons_js_24px_mi-train-front_js"
	],
	"./24px/mi-trash.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-trash.js",
		"node_modules_maersk-global_icons_js_24px_mi-trash_js"
	],
	"./24px/mi-tray-arrow-down.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-tray-arrow-down.js",
		"node_modules_maersk-global_icons_js_24px_mi-tray-arrow-down_js"
	],
	"./24px/mi-tray-arrow-up.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-tray-arrow-up.js",
		"node_modules_maersk-global_icons_js_24px_mi-tray-arrow-up_js"
	],
	"./24px/mi-truck-front-clock.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-truck-front-clock.js",
		"node_modules_maersk-global_icons_js_24px_mi-truck-front-clock_js"
	],
	"./24px/mi-truck-front-pause-circle.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-truck-front-pause-circle.js",
		"node_modules_maersk-global_icons_js_24px_mi-truck-front-pause-circle_js"
	],
	"./24px/mi-truck-front.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-truck-front.js",
		"node_modules_maersk-global_icons_js_24px_mi-truck-front_js"
	],
	"./24px/mi-truck-side-reefer.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-truck-side-reefer.js",
		"node_modules_maersk-global_icons_js_24px_mi-truck-side-reefer_js"
	],
	"./24px/mi-truck-side.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-truck-side.js",
		"node_modules_maersk-global_icons_js_24px_mi-truck-side_js"
	],
	"./24px/mi-tugboat-side.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-tugboat-side.js",
		"node_modules_maersk-global_icons_js_24px_mi-tugboat-side_js"
	],
	"./24px/mi-turnip.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-turnip.js",
		"node_modules_maersk-global_icons_js_24px_mi-turnip_js"
	],
	"./24px/mi-twistlock.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-twistlock.js",
		"node_modules_maersk-global_icons_js_24px_mi-twistlock_js"
	],
	"./24px/mi-user-circle-solid.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-user-circle-solid.js",
		"node_modules_maersk-global_icons_js_24px_mi-user-circle-solid_js"
	],
	"./24px/mi-user-circle.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-user-circle.js",
		"node_modules_maersk-global_icons_js_24px_mi-user-circle_js"
	],
	"./24px/mi-user-cog.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-user-cog.js",
		"node_modules_maersk-global_icons_js_24px_mi-user-cog_js"
	],
	"./24px/mi-user-key.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-user-key.js",
		"node_modules_maersk-global_icons_js_24px_mi-user-key_js"
	],
	"./24px/mi-user-plus-circle.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-user-plus-circle.js",
		"node_modules_maersk-global_icons_js_24px_mi-user-plus-circle_js"
	],
	"./24px/mi-user-solid.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-user-solid.js",
		"node_modules_maersk-global_icons_js_24px_mi-user-solid_js"
	],
	"./24px/mi-user-text-rectangle.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-user-text-rectangle.js",
		"node_modules_maersk-global_icons_js_24px_mi-user-text-rectangle_js"
	],
	"./24px/mi-user.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-user.js",
		"node_modules_maersk-global_icons_js_24px_mi-user_js"
	],
	"./24px/mi-users-solid.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-users-solid.js",
		"node_modules_maersk-global_icons_js_24px_mi-users-solid_js"
	],
	"./24px/mi-users.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-users.js",
		"node_modules_maersk-global_icons_js_24px_mi-users_js"
	],
	"./24px/mi-vessel-front.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-vessel-front.js",
		"node_modules_maersk-global_icons_js_24px_mi-vessel-front_js"
	],
	"./24px/mi-vessel-side-arrow-down-up.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-vessel-side-arrow-down-up.js",
		"node_modules_maersk-global_icons_js_24px_mi-vessel-side-arrow-down-up_js"
	],
	"./24px/mi-vessel-side-arrow-down.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-vessel-side-arrow-down.js",
		"node_modules_maersk-global_icons_js_24px_mi-vessel-side-arrow-down_js"
	],
	"./24px/mi-vessel-side-arrow-up.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-vessel-side-arrow-up.js",
		"node_modules_maersk-global_icons_js_24px_mi-vessel-side-arrow-up_js"
	],
	"./24px/mi-vessel-side.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-vessel-side.js",
		"node_modules_maersk-global_icons_js_24px_mi-vessel-side_js"
	],
	"./24px/mi-video-clapperboard.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-video-clapperboard.js",
		"node_modules_maersk-global_icons_js_24px_mi-video-clapperboard_js"
	],
	"./24px/mi-video.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-video.js",
		"node_modules_maersk-global_icons_js_24px_mi-video_js"
	],
	"./24px/mi-warehouse-reefer.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-warehouse-reefer.js",
		"node_modules_maersk-global_icons_js_24px_mi-warehouse-reefer_js"
	],
	"./24px/mi-warehouse.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-warehouse.js",
		"node_modules_maersk-global_icons_js_24px_mi-warehouse_js"
	],
	"./24px/mi-webhook.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-webhook.js",
		"node_modules_maersk-global_icons_js_24px_mi-webhook_js"
	],
	"./24px/mi-wifi-offline.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-wifi-offline.js",
		"node_modules_maersk-global_icons_js_24px_mi-wifi-offline_js"
	],
	"./24px/mi-wifi.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-wifi.js",
		"node_modules_maersk-global_icons_js_24px_mi-wifi_js"
	],
	"./24px/mi-wrench.js": [
		"./node_modules/@maersk-global/icons/js/24px/mi-wrench.js",
		"node_modules_maersk-global_icons_js_24px_mi-wrench_js"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = "./node_modules/@maersk-global/icons/js ./node_modules/@maersk-global/icons/js lazy recursive ^\\.\\/.*px\\/mi\\-.*\\.js$";
module.exports = webpackAsyncContext;